/* tslint:disable */
/* eslint-disable */
/**
 * Multi-tenancy Rewards API
 * API documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessTokenOnlyDto
 */
export interface AccessTokenOnlyDto {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenOnlyDto
     */
    'access_token'?: string;
}
/**
 * 
 * @export
 * @interface ActivateCardSeriesByPinDto
 */
export interface ActivateCardSeriesByPinDto {
    /**
     * 
     * @type {string}
     * @memberof ActivateCardSeriesByPinDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ActivateCardSeriesByPinDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof ActivateCardSeriesByPinDto
     */
    'pin': string;
}
/**
 * 
 * @export
 * @interface ActivateCardSeriesDto
 */
export interface ActivateCardSeriesDto {
    /**
     * 
     * @type {string}
     * @memberof ActivateCardSeriesDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ActivateCardSeriesDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof ActivateCardSeriesDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface AuthenticationControllerAuthenticate201Response
 */
export interface AuthenticationControllerAuthenticate201Response {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationControllerAuthenticate201Response
     */
    'message'?: string;
    /**
     * 
     * @type {TokenDto}
     * @memberof AuthenticationControllerAuthenticate201Response
     */
    'data'?: TokenDto;
}
/**
 * 
 * @export
 * @interface AuthenticationControllerRefreshRenew201Response
 */
export interface AuthenticationControllerRefreshRenew201Response {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationControllerRefreshRenew201Response
     */
    'message'?: string;
    /**
     * 
     * @type {RenewRefreshTokenDto}
     * @memberof AuthenticationControllerRefreshRenew201Response
     */
    'data'?: RenewRefreshTokenDto;
}
/**
 * 
 * @export
 * @interface AutoAssignCardSeriesDto
 */
export interface AutoAssignCardSeriesDto {
    /**
     * 
     * @type {string}
     * @memberof AutoAssignCardSeriesDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof AutoAssignCardSeriesDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutoAssignCardSeriesDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface BlockPersonDto
 */
export interface BlockPersonDto {
    /**
     * 
     * @type {boolean}
     * @memberof BlockPersonDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof BlockPersonDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockPersonDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof BlockPersonDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockPersonDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof BlockPersonDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockPersonDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockPersonDto
     */
    'code': string;
    /**
     * IF set as TRUE then the user will not be allowed to login ELSE the user will still be allowed to login.
     * @type {boolean}
     * @memberof BlockPersonDto
     */
    'is_blocked'?: boolean;
}
/**
 * 
 * @export
 * @interface CampaignControllerGet200Response
 */
export interface CampaignControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof CampaignControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetCampaignDto>}
     * @memberof CampaignControllerGet200Response
     */
    'data'?: Array<GetCampaignDto>;
}
/**
 * 
 * @export
 * @interface CardSeriesControllerGet200Response
 */
export interface CardSeriesControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof CardSeriesControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetCardSeriesDto>}
     * @memberof CardSeriesControllerGet200Response
     */
    'data'?: Array<GetCardSeriesDto>;
}
/**
 * 
 * @export
 * @interface CardsDto
 */
export interface CardsDto {
    /**
     * 
     * @type {string}
     * @memberof CardsDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CardsDto
     */
    'card_alias'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CardsDto
     */
    'activation_date'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CardsDto
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardsDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardsDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardsDto
     */
    'card_category_description'?: string;
}
/**
 * 
 * @export
 * @interface CoreApiPaginatedResponse
 */
export interface CoreApiPaginatedResponse {
    /**
     * 
     * @type {number}
     * @memberof CoreApiPaginatedResponse
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface CreateActivityLogDto
 */
export interface CreateActivityLogDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateActivityLogDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'request_code'?: string;
    /**
     * describes the database table source
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'request_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'tenant': string;
    /**
     * CREATE | UPDATE | DELETE
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivityLogDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface CreateAttachmentTypeDto
 */
export interface CreateAttachmentTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateAttachmentTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentTypeDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateBranchDto
 */
export interface CreateBranchDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateBranchDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateBranchDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateBranchDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateBranchDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'head'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBranchDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateCampaignDto
 */
export interface CreateCampaignDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignDto
     */
    'redeem_by_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignDto
     */
    'redeem_by_stamp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignDto
     */
    'multi_redeem'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignDto
     */
    'redeem_limit'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'start_date': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof CreateCampaignDto
     */
    'constraint'?: string;
}
/**
 * 
 * @export
 * @interface CreateCardCategoryDto
 */
export interface CreateCardCategoryDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCardCategoryDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCardCategoryDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCardCategoryDto
     */
    'expiration_years'?: number;
}
/**
 * 
 * @export
 * @interface CreateConfigDto
 */
export interface CreateConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateConfigDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateConfigDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateConfigDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateConfigDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateCreditTypeDto
 */
export interface CreateCreditTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCreditTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCreditTypeDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateDebitTypeDto
 */
export interface CreateDebitTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateDebitTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDebitTypeDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateItemDto
 */
export interface CreateItemDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateItemDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateItemDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateItemDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateItemDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateItemDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateItemDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateLedgerDto
 */
export interface CreateLedgerDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateLedgerDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'tenant': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'type': string;
    /**
     * CREDIT | DEBIT
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'batch': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLedgerDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLedgerDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface CreateLevelDto
 */
export interface CreateLevelDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateLevelDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateLevelDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateLevelDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateLevelDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLevelDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLevelDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLevelDto
     */
    'stamp'?: number;
    /**
     * AND | OR
     * @type {string}
     * @memberof CreateLevelDto
     */
    'constraint'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLevelDto
     */
    'max_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLevelDto
     */
    'max_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLevelDto
     */
    'max_points_per_day'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLevelDto
     */
    'max_stamp_per_day'?: number;
}
/**
 * 
 * @export
 * @interface CreatePersonAddressDto
 */
export interface CreatePersonAddressDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonAddressDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'street_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'subdivision'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'zone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'sitio'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'purok'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'barangay'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'municipality'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'province'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonAddressDto
     */
    'zip'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonAddressDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonAddressDto
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface CreatePersonExtendedDto
 */
export interface CreatePersonExtendedDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonExtendedDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonExtendedDto
     */
    'is_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'activation_code'?: string;
    /**
     * MALE | FEMALE
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'gender': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonExtendedDto
     */
    'is_blocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'father_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'mother_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'emergency_contact_1_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'emergency_contact_1_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'emergency_contact_1_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'emergency_contact_2_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'emergency_contact_2_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'emergency_contact_2_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'sss'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'philhealth'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'pagibig'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'tin'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'medical_condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'blood_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'elementary'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'high_school'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'college'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'post_college'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'undergraduate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'curriculum_vitae'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'supporting_doc'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'intent_letter'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonExtendedDto
     */
    'application_letter'?: string;
    /**
     * 
     * @type {CreatePersonAddressDto}
     * @memberof CreatePersonExtendedDto
     */
    'address'?: CreatePersonAddressDto;
}
/**
 * 
 * @export
 * @interface CreateRegistrationDto
 */
export interface CreateRegistrationDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRegistrationDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'tenant': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'last_name': string;
    /**
     * MALE | FEMALE
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'gender'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'avatar'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'expiration'?: string;
    /**
     * PENDING | PROCESSED | EXPIRED
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegistrationDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface CreateRequestDto
 */
export interface CreateRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRequestDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'tenant': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'card_series'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDto
     */
    'campaign': string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestDto
     */
    'expiration'?: string;
    /**
     * PENDING | USED | EXPIRED
     * @type {string}
     * @memberof CreateRequestDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface CreateRequestTypeDto
 */
export interface CreateRequestTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRequestTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestTypeDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateRewardDto
 */
export interface CreateRewardDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardDto
     */
    'is_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardDto
     */
    'is_stamp'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardDto
     */
    'denomination_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardDto
     */
    'denomination_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardDto
     */
    'stamp'?: number;
}
/**
 * 
 * @export
 * @interface CreateRewardEventDto
 */
export interface CreateRewardEventDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardEventDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardEventDto
     */
    'is_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardEventDto
     */
    'is_stamp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardEventDto
     */
    'is_level'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardEventDto
     */
    'denomination_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardEventDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardEventDto
     */
    'denomination_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardEventDto
     */
    'stamp'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'start_date': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof CreateRewardEventDto
     */
    'constraint'?: string;
}
/**
 * 
 * @export
 * @interface CreateRewardTypeDto
 */
export interface CreateRewardTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardTypeDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRoleDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRoleDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateRoleDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateServiceDto
 */
export interface CreateServiceDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateServiceDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateServiceDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateServiceDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateServiceDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceDto
     */
    'duration'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServiceDto
     */
    'is_open_time'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceDto
     */
    'upgrade': number;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface CreateStatusDto
 */
export interface CreateStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateStatusDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateStatusDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateStatusDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateStatusDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateTenantDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateTenantDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateTenantDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'business_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'business_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'website': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof CreateTenantDto
     */
    'membership_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'rewards_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'post_registration_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'post_registration_message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'is_merged_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'is_merged_stamp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'pre_registration_message'?: string;
}
/**
 * 
 * @export
 * @interface CreateTransactionDto
 */
export interface CreateTransactionDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateTransactionDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'user_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'card_series'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'reward'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTransactionDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTransactionDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTransactionDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface DeleteActivityLogDto
 */
export interface DeleteActivityLogDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteActivityLogDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteActivityLogDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteAttachmentTypeDto
 */
export interface DeleteAttachmentTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteAttachmentTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteAttachmentTypeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteBranchDto
 */
export interface DeleteBranchDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteBranchDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteBranchDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteCampaignDto
 */
export interface DeleteCampaignDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCampaignDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCampaignDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteCardCategoryDto
 */
export interface DeleteCardCategoryDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCardCategoryDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardCategoryDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteCardSeriesDto
 */
export interface DeleteCardSeriesDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCardSeriesDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCardSeriesDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteConfigDto
 */
export interface DeleteConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteConfigDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteConfigDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteCreditTypeDto
 */
export interface DeleteCreditTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCreditTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCreditTypeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteDebitTypeDto
 */
export interface DeleteDebitTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteDebitTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteDebitTypeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteItemDto
 */
export interface DeleteItemDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteItemDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteItemDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteItemDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteItemDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteItemDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteItemDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteItemDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteItemDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteLedgerDto
 */
export interface DeleteLedgerDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteLedgerDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLedgerDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteLevelDto
 */
export interface DeleteLevelDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteLevelDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLevelDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeletePersonAddressDto
 */
export interface DeletePersonAddressDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeletePersonAddressDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonAddressDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeletePersonDto
 */
export interface DeletePersonDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeletePersonDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeletePersonDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeletePersonDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeletePersonDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePersonDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteRegistrationDto
 */
export interface DeleteRegistrationDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteRegistrationDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRegistrationDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteRequestTypeDto
 */
export interface DeleteRequestTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteRequestTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRequestTypeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteRewardDto
 */
export interface DeleteRewardDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteRewardDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteRewardEventDto
 */
export interface DeleteRewardEventDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteRewardEventDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardEventDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteRewardTypeDto
 */
export interface DeleteRewardTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteRewardTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRewardTypeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteRoleDto
 */
export interface DeleteRoleDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteRoleDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteRoleDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteServiceDto
 */
export interface DeleteServiceDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteServiceDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteServiceDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteStatusDto
 */
export interface DeleteStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteStatusDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteStatusDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteTenantDto
 */
export interface DeleteTenantDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteTenantDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTenantDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeleteTransactionDto
 */
export interface DeleteTransactionDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteTransactionDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteTransactionDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DeviceAuthorization
 */
export interface DeviceAuthorization {
    /**
     * 
     * @type {boolean}
     * @memberof DeviceAuthorization
     */
    'authorize': boolean;
}
/**
 * 
 * @export
 * @interface DeviceRegistrationControllerRegister201Response
 */
export interface DeviceRegistrationControllerRegister201Response {
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistrationControllerRegister201Response
     */
    'message'?: string;
    /**
     * 
     * @type {AccessTokenOnlyDto}
     * @memberof DeviceRegistrationControllerRegister201Response
     */
    'data'?: AccessTokenOnlyDto;
}
/**
 * 
 * @export
 * @interface EarnRewardDto
 */
export interface EarnRewardDto {
    /**
     * 
     * @type {string}
     * @memberof EarnRewardDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EarnRewardDto
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof EarnRewardDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {number}
     * @memberof EarnRewardDto
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface EditActivityLogDto
 */
export interface EditActivityLogDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditActivityLogDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'request_code'?: string;
    /**
     * describes the database table source
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'request_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'tenant': string;
    /**
     * CREATE | UPDATE | DELETE
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditActivityLogDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface EditAttachmentTypeDto
 */
export interface EditAttachmentTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditAttachmentTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditAttachmentTypeDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface EditBranchDto
 */
export interface EditBranchDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditBranchDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditBranchDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditBranchDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditBranchDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'head'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditBranchDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditCampaignDto
 */
export interface EditCampaignDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditCampaignDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCampaignDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCampaignDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCampaignDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCampaignDto
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditCampaignDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCampaignDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCampaignDto
     */
    'redeem_by_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCampaignDto
     */
    'redeem_by_stamp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCampaignDto
     */
    'multi_redeem'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditCampaignDto
     */
    'redeem_limit'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof EditCampaignDto
     */
    'start_date'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof EditCampaignDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof EditCampaignDto
     */
    'constraint'?: string;
}
/**
 * 
 * @export
 * @interface EditCardCategoryDto
 */
export interface EditCardCategoryDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditCardCategoryDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCardCategoryDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditCardCategoryDto
     */
    'expiration_years'?: number;
}
/**
 * 
 * @export
 * @interface EditConfigDto
 */
export interface EditConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditConfigDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditConfigDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditConfigDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditConfigDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof EditConfigDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditCreditTypeDto
 */
export interface EditCreditTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditCreditTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCreditTypeDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditDebitTypeDto
 */
export interface EditDebitTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditDebitTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditDebitTypeDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditItemDto
 */
export interface EditItemDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditItemDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditItemDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditItemDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditItemDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditItemDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof EditItemDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditLedgerDto
 */
export interface EditLedgerDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditLedgerDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditLedgerDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditLedgerDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditLedgerDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'tenant': string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'type': string;
    /**
     * CREDIT | DEBIT
     * @type {string}
     * @memberof EditLedgerDto
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'batch': string;
    /**
     * 
     * @type {number}
     * @memberof EditLedgerDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof EditLedgerDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface EditLevelDto
 */
export interface EditLevelDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditLevelDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditLevelDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditLevelDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditLevelDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLevelDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditLevelDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLevelDto
     */
    'stamp'?: number;
    /**
     * AND | OR
     * @type {string}
     * @memberof EditLevelDto
     */
    'constraint'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditLevelDto
     */
    'max_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLevelDto
     */
    'max_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLevelDto
     */
    'max_points_per_day'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLevelDto
     */
    'max_stamp_per_day'?: number;
}
/**
 * 
 * @export
 * @interface EditPersonAddressDto
 */
export interface EditPersonAddressDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditPersonAddressDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'street_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'subdivision'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'zone'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'sitio'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'purok'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'barangay'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'municipality'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'province'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonAddressDto
     */
    'zip'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditPersonAddressDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditPersonAddressDto
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface EditPersonExtendedDto
 */
export interface EditPersonExtendedDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditPersonExtendedDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditPersonExtendedDto
     */
    'is_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'activation_code'?: string;
    /**
     * MALE | FEMALE
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'gender': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditPersonExtendedDto
     */
    'is_blocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'father_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'mother_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'emergency_contact_1_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'emergency_contact_1_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'emergency_contact_1_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'emergency_contact_2_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'emergency_contact_2_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'emergency_contact_2_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'sss'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'philhealth'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'pagibig'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'tin'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'medical_condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'blood_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'elementary'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'high_school'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'college'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'post_college'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'undergraduate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'curriculum_vitae'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'supporting_doc'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'intent_letter'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPersonExtendedDto
     */
    'application_letter'?: string;
    /**
     * 
     * @type {EditPersonAddressDto}
     * @memberof EditPersonExtendedDto
     */
    'address'?: EditPersonAddressDto;
}
/**
 * 
 * @export
 * @interface EditRequestTypeDto
 */
export interface EditRequestTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditRequestTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditRequestTypeDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface EditRewardDto
 */
export interface EditRewardDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardDto
     */
    'is_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardDto
     */
    'is_stamp'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditRewardDto
     */
    'denomination_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditRewardDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditRewardDto
     */
    'denomination_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditRewardDto
     */
    'stamp'?: number;
}
/**
 * 
 * @export
 * @interface EditRewardEventDto
 */
export interface EditRewardEventDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardEventDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardEventDto
     */
    'is_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardEventDto
     */
    'is_stamp'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditRewardEventDto
     */
    'denomination_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditRewardEventDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditRewardEventDto
     */
    'denomination_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditRewardEventDto
     */
    'stamp'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'start_date': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof EditRewardEventDto
     */
    'constraint'?: string;
}
/**
 * 
 * @export
 * @interface EditRewardTypeDto
 */
export interface EditRewardTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditRewardTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRewardTypeDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditRoleDto
 */
export interface EditRoleDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditRoleDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRoleDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRoleDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRoleDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRoleDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditRoleDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRoleDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRoleDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditRoleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditRoleDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface EditServiceDto
 */
export interface EditServiceDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditServiceDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditServiceDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditServiceDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditServiceDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditServiceDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof EditServiceDto
     */
    'duration'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditServiceDto
     */
    'is_open_time'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditServiceDto
     */
    'upgrade': number;
    /**
     * 
     * @type {string}
     * @memberof EditServiceDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface EditStatusDto
 */
export interface EditStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditStatusDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditStatusDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStatusDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditStatusDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStatusDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditStatusDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStatusDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStatusDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditStatusDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditStatusDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface EditTenantDto
 */
export interface EditTenantDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditTenantDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTenantDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTenantDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTenantDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'business_name': string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'business_type': string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'website': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof EditTenantDto
     */
    'membership_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'rewards_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'post_registration_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'post_registration_message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditTenantDto
     */
    'is_merged_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditTenantDto
     */
    'is_merged_stamp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditTenantDto
     */
    'pre_registration_message'?: string;
}
/**
 * 
 * @export
 * @interface EditTransactionDto
 */
export interface EditTransactionDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditTransactionDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTransactionDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTransactionDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTransactionDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'user_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'card_series'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'reward'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof EditTransactionDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditTransactionDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditTransactionDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'remarks'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof EditTransactionDto
     */
    'voided_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditTransactionDto
     */
    'voided_by'?: string;
}
/**
 * 
 * @export
 * @interface ExtendCardSeriesDto
 */
export interface ExtendCardSeriesDto {
    /**
     * 
     * @type {string}
     * @memberof ExtendCardSeriesDto
     */
    'code': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof ExtendCardSeriesDto
     */
    'expiration_date': string;
}
/**
 * 
 * @export
 * @interface GenerateCardSeriesDto
 */
export interface GenerateCardSeriesDto {
    /**
     * 
     * @type {boolean}
     * @memberof GenerateCardSeriesDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCardSeriesDto
     */
    'card_category': string;
    /**
     * 
     * @type {number}
     * @memberof GenerateCardSeriesDto
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface GenericErrorResponseDto
 */
export interface GenericErrorResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GenericErrorResponseDto
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof GenericErrorResponseDto
     */
    'status_code'?: number;
}
/**
 * 
 * @export
 * @interface GenericReportDataDto
 */
export interface GenericReportDataDto {
    /**
     * 
     * @type {number}
     * @memberof GenericReportDataDto
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof GenericReportDataDto
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface GetActivityLogDto
 */
export interface GetActivityLogDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetActivityLogDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'request_code'?: string;
    /**
     * describes the database table source
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'request_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'tenant': string;
    /**
     * CREATE | UPDATE | DELETE
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivityLogDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface GetAttachmentTypeDto
 */
export interface GetAttachmentTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetAttachmentTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentTypeDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GetBranchDto
 */
export interface GetBranchDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetBranchDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetBranchDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetBranchDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetBranchDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'head'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'head_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'head_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'head_last_name': string;
    /**
     * 
     * @type {number}
     * @memberof GetBranchDto
     */
    'population'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBranchDto
     */
    'tenant_name'?: string;
}
/**
 * 
 * @export
 * @interface GetCampaignDto
 */
export interface GetCampaignDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetCampaignDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCampaignDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCampaignDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCampaignDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'card_category_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'level_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'level_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'level_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignDto
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCampaignDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCampaignDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCampaignDto
     */
    'redeem_by_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCampaignDto
     */
    'redeem_by_stamp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCampaignDto
     */
    'multi_redeem'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetCampaignDto
     */
    'redeem_limit'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetCampaignDto
     */
    'start_date'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetCampaignDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof GetCampaignDto
     */
    'constraint'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCampaignDto
     */
    'total_redeem_count'?: number;
}
/**
 * 
 * @export
 * @interface GetCardCategoryDto
 */
export interface GetCardCategoryDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetCardCategoryDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardCategoryDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCardCategoryDto
     */
    'expiration_years'?: number;
}
/**
 * 
 * @export
 * @interface GetCardSeriesDto
 */
export interface GetCardSeriesDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetCardSeriesDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'card_owner_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'card_owner_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'card_owner_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'card_alias'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'activation_date'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardSeriesDto
     */
    'is_blocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardSeriesDto
     */
    'is_lost'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardSeriesDto
     */
    'is_stolen'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'remarks'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCardSeriesDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCardSeriesDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCardSeriesDto
     */
    'nickname'?: string;
}
/**
 * 
 * @export
 * @interface GetConfigDto
 */
export interface GetConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetConfigDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetConfigDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetConfigDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetConfigDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetConfigDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface GetCreditTypeDto
 */
export interface GetCreditTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetCreditTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCreditTypeDto
     */
    'tenant_name'?: string;
}
/**
 * 
 * @export
 * @interface GetDebitTypeDto
 */
export interface GetDebitTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetDebitTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDebitTypeDto
     */
    'tenant_name'?: string;
}
/**
 * 
 * @export
 * @interface GetItemDto
 */
export interface GetItemDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetItemDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetItemDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetItemDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetItemDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetItemDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetItemDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface GetLedgerDto
 */
export interface GetLedgerDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetLedgerDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetLedgerDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetLedgerDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetLedgerDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'tenant': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'type_name': string;
    /**
     * CREDIT | DEBIT
     * @type {string}
     * @memberof GetLedgerDto
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'batch': string;
    /**
     * 
     * @type {number}
     * @memberof GetLedgerDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface GetLevelDto
 */
export interface GetLevelDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetLevelDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetLevelDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetLevelDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetLevelDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetLevelDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLevelDto
     */
    'stamp'?: number;
    /**
     * AND | OR
     * @type {string}
     * @memberof GetLevelDto
     */
    'constraint'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetLevelDto
     */
    'max_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLevelDto
     */
    'max_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLevelDto
     */
    'max_points_per_day'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLevelDto
     */
    'max_stamp_per_day'?: number;
}
/**
 * 
 * @export
 * @interface GetPersonAddressDto
 */
export interface GetPersonAddressDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetPersonAddressDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'person_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'person_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'person_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'street_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'subdivision'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'zone'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'sitio'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'purok'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'barangay'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'municipality'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'province'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonAddressDto
     */
    'zip'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPersonAddressDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPersonAddressDto
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface GetPersonDto
 */
export interface GetPersonDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetPersonDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'business_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'branch_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'role_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'role_description': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPersonDto
     */
    'is_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'activation_code'?: string;
    /**
     * MALE | FEMALE
     * @type {string}
     * @memberof GetPersonDto
     */
    'gender': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetPersonDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPersonDto
     */
    'is_blocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'father_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'mother_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'emergency_contact_1_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'emergency_contact_1_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'emergency_contact_1_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'emergency_contact_2_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'emergency_contact_2_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'emergency_contact_2_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'sss'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'philhealth'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'pagibig'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'tin'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'medical_condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'blood_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'elementary'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'high_school'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'college'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'post_college'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'undergraduate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'curriculum_vitae'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'supporting_doc'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'intent_letter'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPersonDto
     */
    'application_letter'?: string;
    /**
     * 
     * @type {GetPersonAddressDto}
     * @memberof GetPersonDto
     */
    'address': GetPersonAddressDto;
    /**
     * 
     * @type {number}
     * @memberof GetPersonDto
     */
    'login_attempt'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPersonDto
     */
    'is_locked'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetPersonDto
     */
    'locked_at'?: string;
}
/**
 * 
 * @export
 * @interface GetRegistrationDto
 */
export interface GetRegistrationDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRegistrationDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'branch_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'branch_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'card_category_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'last_name'?: string;
    /**
     * MALE | FEMALE
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'gender'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'avatar'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'expiration'?: string;
    /**
     * PENDING | PROCESSED | EXPIRED
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegistrationDto
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface GetRequestDto
 */
export interface GetRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRequestDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'tenant': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'card_series'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'card_alias'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'campaign_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestDto
     */
    'campaign_description': string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestDto
     */
    'expiration'?: string;
    /**
     * PENDING | USED | EXPIRED
     * @type {string}
     * @memberof GetRequestDto
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface GetRequestTypeDto
 */
export interface GetRequestTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRequestTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRequestTypeDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GetRewardCampaignDto
 */
export interface GetRewardCampaignDto {
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'card_category_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'level_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'level_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'level_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetRewardCampaignDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardCampaignDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardCampaignDto
     */
    'redeem_by_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardCampaignDto
     */
    'redeem_by_stamp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardCampaignDto
     */
    'multi_redeem'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetRewardCampaignDto
     */
    'redeem_limit'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'start_date'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof GetRewardCampaignDto
     */
    'constraint'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardCampaignDto
     */
    'is_redeemable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetRewardCampaignDto
     */
    'redeem_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardCampaignDto
     */
    'total_redeem_count'?: number;
}
/**
 * 
 * @export
 * @interface GetRewardDto
 */
export interface GetRewardDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardDto
     */
    'is_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardDto
     */
    'is_stamp'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetRewardDto
     */
    'denomination_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardDto
     */
    'denomination_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardDto
     */
    'stamp'?: number;
}
/**
 * 
 * @export
 * @interface GetRewardEventDto
 */
export interface GetRewardEventDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardEventDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'level_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'level_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'level_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'card_category_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardEventDto
     */
    'is_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardEventDto
     */
    'is_stamp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardEventDto
     */
    'is_level'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetRewardEventDto
     */
    'denomination_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardEventDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardEventDto
     */
    'denomination_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardEventDto
     */
    'stamp'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'start_date': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'end_date'?: string;
    /**
     * AND | OR
     * @type {string}
     * @memberof GetRewardEventDto
     */
    'constraint'?: string;
}
/**
 * 
 * @export
 * @interface GetRewardTypeDto
 */
export interface GetRewardTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardTypeDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRewardTypeDto
     */
    'tenant_name'?: string;
}
/**
 * 
 * @export
 * @interface GetRoleDto
 */
export interface GetRoleDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetRoleDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRoleDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRoleDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetRoleDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GetServiceDto
 */
export interface GetServiceDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetServiceDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetServiceDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetServiceDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetServiceDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetServiceDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceDto
     */
    'duration'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetServiceDto
     */
    'is_open_time'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetServiceDto
     */
    'upgrade': number;
    /**
     * 
     * @type {string}
     * @memberof GetServiceDto
     */
    'tenant'?: string;
}
/**
 * 
 * @export
 * @interface GetStatusDto
 */
export interface GetStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetStatusDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetStatusDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetStatusDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetStatusDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStatusDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GetTenantDto
 */
export interface GetTenantDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTenantDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTenantDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTenantDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'business_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'business_type': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'website': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof GetTenantDto
     */
    'membership_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'rewards_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'post_registration_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'post_registration_message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantDto
     */
    'is_merged_points'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantDto
     */
    'is_merged_stamp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTenantDto
     */
    'pre_registration_message'?: string;
}
/**
 * 
 * @export
 * @interface GetTransactionDto
 */
export interface GetTransactionDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTransactionDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTransactionDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTransactionDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'created_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'created_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'created_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'updated_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'updated_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'updated_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'deleted_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'deleted_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'deleted_last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'business_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'branch_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'user_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'card_series'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'card_alias'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'card_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'card_category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'reward'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'reward_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'campaign_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'remarks'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTransactionDto
     */
    'voided_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'voided_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'voided_first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'voided_middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'voided_last_name'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof GetTransactionDto
     */
    'void_request_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionDto
     */
    'void_request_by'?: string;
}
/**
 * 
 * @export
 * @interface LedgerControllerGet200Response
 */
export interface LedgerControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof LedgerControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetLedgerDto>}
     * @memberof LedgerControllerGet200Response
     */
    'data'?: Array<GetLedgerDto>;
}
/**
 * 
 * @export
 * @interface MembersDto
 */
export interface MembersDto {
    /**
     * 
     * @type {boolean}
     * @memberof MembersDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof MembersDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof MembersDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof MembersDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'username'?: string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof MembersDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'mobile_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'role_name': string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'role_description': string;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'total_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'exp_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'total_redeem_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'current_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'exp_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'total_redeem_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'current_stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'level_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'level_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MembersDto
     */
    'level_avatar'?: string;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'level_points_cap'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'level_stamp_cap'?: number;
    /**
     * AND | OR
     * @type {string}
     * @memberof MembersDto
     */
    'level_constraint'?: string;
    /**
     * 
     * @type {number}
     * @memberof MembersDto
     */
    'total_cards'?: number;
    /**
     * 
     * @type {Array<CardsDto>}
     * @memberof MembersDto
     */
    'cards'?: Array<CardsDto>;
}
/**
 * 
 * @export
 * @interface MessageArrayDataResponseDto
 */
export interface MessageArrayDataResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MessageArrayDataResponseDto
     */
    'message': string;
    /**
     * 
     * @type {Array<MessageWithIdentifierDto>}
     * @memberof MessageArrayDataResponseDto
     */
    'data': Array<MessageWithIdentifierDto>;
}
/**
 * 
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MessageResponseDto
     */
    'message'?: string;
    /**
     * 
     * @type {object}
     * @memberof MessageResponseDto
     */
    'data'?: object;
}
/**
 * 
 * @export
 * @interface MessageWithIdentifierDto
 */
export interface MessageWithIdentifierDto {
    /**
     * 
     * @type {string}
     * @memberof MessageWithIdentifierDto
     */
    'identifier': string;
    /**
     * 
     * @type {string}
     * @memberof MessageWithIdentifierDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface PersonAddressControllerGet200Response
 */
export interface PersonAddressControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof PersonAddressControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetPersonAddressDto>}
     * @memberof PersonAddressControllerGet200Response
     */
    'data'?: Array<GetPersonAddressDto>;
}
/**
 * 
 * @export
 * @interface PersonControllerActivity200Response
 */
export interface PersonControllerActivity200Response {
    /**
     * 
     * @type {number}
     * @memberof PersonControllerActivity200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetActivityLogDto>}
     * @memberof PersonControllerActivity200Response
     */
    'data'?: Array<GetActivityLogDto>;
}
/**
 * 
 * @export
 * @interface PersonControllerGet200Response
 */
export interface PersonControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof PersonControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetPersonDto>}
     * @memberof PersonControllerGet200Response
     */
    'data'?: Array<GetPersonDto>;
}
/**
 * 
 * @export
 * @interface ProcessRegistrationDto
 */
export interface ProcessRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessRegistrationDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ProcessRegistrationDto
     */
    'branch'?: string;
}
/**
 * 
 * @export
 * @interface RedeemRewardDto
 */
export interface RedeemRewardDto {
    /**
     * 
     * @type {string}
     * @memberof RedeemRewardDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RedeemRewardDto
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof RedeemRewardDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemRewardDto
     */
    'campaign': string;
    /**
     * POINTS | STAMP
     * @type {string}
     * @memberof RedeemRewardDto
     */
    'preference'?: string;
    /**
     * 
     * @type {number}
     * @memberof RedeemRewardDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof RedeemRewardDto
     */
    'stamp'?: number;
}
/**
 * 
 * @export
 * @interface RegistrationControllerGet200Response
 */
export interface RegistrationControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof RegistrationControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRegistrationDto>}
     * @memberof RegistrationControllerGet200Response
     */
    'data'?: Array<GetRegistrationDto>;
}
/**
 * 
 * @export
 * @interface RenewRefreshTokenDto
 */
export interface RenewRefreshTokenDto {
    /**
     * 
     * @type {string}
     * @memberof RenewRefreshTokenDto
     */
    'user_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof RenewRefreshTokenDto
     */
    'refresh_token'?: string;
    /**
     * 
     * @type {number}
     * @memberof RenewRefreshTokenDto
     */
    'refresh_exp'?: number;
}
/**
 * 
 * @export
 * @interface ReportBirthdayDto
 */
export interface ReportBirthdayDto {
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'business_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'role_name': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'role_description': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'middle_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'avatar'?: string;
    /**
     * MALE | FEMALE
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'gender': string;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof ReportBirthdayDto
     */
    'birthday'?: string;
}
/**
 * 
 * @export
 * @interface ReportControllerBirthday200Response
 */
export interface ReportControllerBirthday200Response {
    /**
     * 
     * @type {number}
     * @memberof ReportControllerBirthday200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ReportBirthdayDto>}
     * @memberof ReportControllerBirthday200Response
     */
    'data'?: Array<ReportBirthdayDto>;
}
/**
 * 
 * @export
 * @interface ReportControllerCardStats200Response
 */
export interface ReportControllerCardStats200Response {
    /**
     * 
     * @type {Array<GenericReportDataDto>}
     * @memberof ReportControllerCardStats200Response
     */
    'data'?: Array<GenericReportDataDto>;
}
/**
 * 
 * @export
 * @interface ReportControllerRank200Response
 */
export interface ReportControllerRank200Response {
    /**
     * 
     * @type {number}
     * @memberof ReportControllerRank200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ReportRankDto>}
     * @memberof ReportControllerRank200Response
     */
    'data'?: Array<ReportRankDto>;
}
/**
 * 
 * @export
 * @interface ReportControllerTransaction200Response
 */
export interface ReportControllerTransaction200Response {
    /**
     * 
     * @type {Array<ReportTransactionDto>}
     * @memberof ReportControllerTransaction200Response
     */
    'data'?: Array<ReportTransactionDto>;
}
/**
 * 
 * @export
 * @interface ReportRankDto
 */
export interface ReportRankDto {
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'tenant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'user_code': string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'role_name': string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'role_description': string;
    /**
     * 
     * @type {number}
     * @memberof ReportRankDto
     */
    'total_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportRankDto
     */
    'exp_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportRankDto
     */
    'exp_stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'level_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'level_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRankDto
     */
    'level_avatar'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportRankDto
     */
    'level_points_cap'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportRankDto
     */
    'level_stamp_cap'?: number;
    /**
     * AND | OR
     * @type {string}
     * @memberof ReportRankDto
     */
    'level_constraint'?: string;
}
/**
 * 
 * @export
 * @interface ReportTransactionDto
 */
export interface ReportTransactionDto {
    /**
     * 
     * @type {number}
     * @memberof ReportTransactionDto
     */
    'earn_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportTransactionDto
     */
    'redeem_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportTransactionDto
     */
    'earn_stamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportTransactionDto
     */
    'redeem_stamp'?: number;
    /**
     * The date of the event. Format: YYYY-MM-DD
     * @type {string}
     * @memberof ReportTransactionDto
     */
    'report_date'?: string;
}
/**
 * 
 * @export
 * @interface RequestControllerGet200Response
 */
export interface RequestControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof RequestControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRequestDto>}
     * @memberof RequestControllerGet200Response
     */
    'data'?: Array<GetRequestDto>;
}
/**
 * 
 * @export
 * @interface RewardControllerCampaign200Response
 */
export interface RewardControllerCampaign200Response {
    /**
     * 
     * @type {Array<GetRewardCampaignDto>}
     * @memberof RewardControllerCampaign200Response
     */
    'data'?: Array<GetRewardCampaignDto>;
}
/**
 * 
 * @export
 * @interface RewardControllerGet200Response
 */
export interface RewardControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof RewardControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRewardDto>}
     * @memberof RewardControllerGet200Response
     */
    'data'?: Array<GetRewardDto>;
}
/**
 * 
 * @export
 * @interface RewardControllerMembers200Response
 */
export interface RewardControllerMembers200Response {
    /**
     * 
     * @type {number}
     * @memberof RewardControllerMembers200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<MembersDto>}
     * @memberof RewardControllerMembers200Response
     */
    'data'?: Array<MembersDto>;
}
/**
 * 
 * @export
 * @interface RewardEventControllerGet200Response
 */
export interface RewardEventControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof RewardEventControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRewardEventDto>}
     * @memberof RewardEventControllerGet200Response
     */
    'data'?: Array<GetRewardEventDto>;
}
/**
 * 
 * @export
 * @interface SetNicknameDto
 */
export interface SetNicknameDto {
    /**
     * 
     * @type {boolean}
     * @memberof SetNicknameDto
     */
    'is_active'?: boolean;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof SetNicknameDto
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetNicknameDto
     */
    'created_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof SetNicknameDto
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetNicknameDto
     */
    'updated_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof SetNicknameDto
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetNicknameDto
     */
    'deleted_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetNicknameDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SetNicknameDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetNicknameDto
     */
    'nickname': string;
}
/**
 * 
 * @export
 * @interface SigninUserRequestDto
 */
export interface SigninUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SigninUserRequestDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof SigninUserRequestDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SigninUserRequestDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof SigninUserRequestDto
     */
    'slug'?: string;
}
/**
 * 
 * @export
 * @interface SwaggerExceptionResponseDto
 */
export interface SwaggerExceptionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SwaggerExceptionResponseDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface TenantControllerGet200Response
 */
export interface TenantControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof TenantControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetTenantDto>}
     * @memberof TenantControllerGet200Response
     */
    'data'?: Array<GetTenantDto>;
}
/**
 * 
 * @export
 * @interface TokenDto
 */
export interface TokenDto {
    /**
     * 
     * @type {string}
     * @memberof TokenDto
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenDto
     */
    'refresh_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenDto
     */
    'user_code'?: string;
    /**
     * 
     * @type {TokenRoleResponseDto}
     * @memberof TokenDto
     */
    'role'?: TokenRoleResponseDto;
    /**
     * 
     * @type {number}
     * @memberof TokenDto
     */
    'access_exp'?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenDto
     */
    'refresh_exp'?: number;
}
/**
 * 
 * @export
 * @interface TokenRoleResponseDto
 */
export interface TokenRoleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRoleResponseDto
     */
    'branch_name'?: string;
}
/**
 * 
 * @export
 * @interface TransactionControllerGet200Response
 */
export interface TransactionControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof TransactionControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetTransactionDto>}
     * @memberof TransactionControllerGet200Response
     */
    'data'?: Array<GetTransactionDto>;
}
/**
 * 
 * @export
 * @interface UnlockPersonDto
 */
export interface UnlockPersonDto {
    /**
     * 
     * @type {string}
     * @memberof UnlockPersonDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UnlockPersonDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface UtilAttachmentTypeControllerGet200Response
 */
export interface UtilAttachmentTypeControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilAttachmentTypeControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetAttachmentTypeDto>}
     * @memberof UtilAttachmentTypeControllerGet200Response
     */
    'data'?: Array<GetAttachmentTypeDto>;
}
/**
 * 
 * @export
 * @interface UtilBranchControllerGet200Response
 */
export interface UtilBranchControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilBranchControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetBranchDto>}
     * @memberof UtilBranchControllerGet200Response
     */
    'data'?: Array<GetBranchDto>;
}
/**
 * 
 * @export
 * @interface UtilCardCategoryControllerGet200Response
 */
export interface UtilCardCategoryControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilCardCategoryControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetCardCategoryDto>}
     * @memberof UtilCardCategoryControllerGet200Response
     */
    'data'?: Array<GetCardCategoryDto>;
}
/**
 * 
 * @export
 * @interface UtilConfigControllerGet200Response
 */
export interface UtilConfigControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilConfigControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetConfigDto>}
     * @memberof UtilConfigControllerGet200Response
     */
    'data'?: Array<GetConfigDto>;
}
/**
 * 
 * @export
 * @interface UtilCreditTypeControllerGet200Response
 */
export interface UtilCreditTypeControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilCreditTypeControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetCreditTypeDto>}
     * @memberof UtilCreditTypeControllerGet200Response
     */
    'data'?: Array<GetCreditTypeDto>;
}
/**
 * 
 * @export
 * @interface UtilDebitTypeControllerGet200Response
 */
export interface UtilDebitTypeControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilDebitTypeControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetDebitTypeDto>}
     * @memberof UtilDebitTypeControllerGet200Response
     */
    'data'?: Array<GetDebitTypeDto>;
}
/**
 * 
 * @export
 * @interface UtilItemControllerGet200Response
 */
export interface UtilItemControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilItemControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetItemDto>}
     * @memberof UtilItemControllerGet200Response
     */
    'data'?: Array<GetItemDto>;
}
/**
 * 
 * @export
 * @interface UtilLevelControllerGet200Response
 */
export interface UtilLevelControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilLevelControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetLevelDto>}
     * @memberof UtilLevelControllerGet200Response
     */
    'data'?: Array<GetLevelDto>;
}
/**
 * 
 * @export
 * @interface UtilRequestTypeControllerGet200Response
 */
export interface UtilRequestTypeControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilRequestTypeControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRequestTypeDto>}
     * @memberof UtilRequestTypeControllerGet200Response
     */
    'data'?: Array<GetRequestTypeDto>;
}
/**
 * 
 * @export
 * @interface UtilRewardTypeControllerGet200Response
 */
export interface UtilRewardTypeControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilRewardTypeControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRewardTypeDto>}
     * @memberof UtilRewardTypeControllerGet200Response
     */
    'data'?: Array<GetRewardTypeDto>;
}
/**
 * 
 * @export
 * @interface UtilRoleControllerGet200Response
 */
export interface UtilRoleControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilRoleControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetRoleDto>}
     * @memberof UtilRoleControllerGet200Response
     */
    'data'?: Array<GetRoleDto>;
}
/**
 * 
 * @export
 * @interface UtilServiceControllerGet200Response
 */
export interface UtilServiceControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilServiceControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetServiceDto>}
     * @memberof UtilServiceControllerGet200Response
     */
    'data'?: Array<GetServiceDto>;
}
/**
 * 
 * @export
 * @interface UtilStatusControllerGet200Response
 */
export interface UtilStatusControllerGet200Response {
    /**
     * 
     * @type {number}
     * @memberof UtilStatusControllerGet200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GetStatusDto>}
     * @memberof UtilStatusControllerGet200Response
     */
    'data'?: Array<GetStatusDto>;
}
/**
 * 
 * @export
 * @interface VoidTransactionDto
 */
export interface VoidTransactionDto {
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'tenant'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'user_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'card_series'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'reward'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof VoidTransactionDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VoidTransactionDto
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof VoidTransactionDto
     */
    'stamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'remarks'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'voided_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'voided_by'?: string;
    /**
     * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'void_request_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'void_request_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoidTransactionDto
     */
    'authentication'?: string;
}

/**
 * ActivityLogApi - axios parameter creator
 * @export
 */
export const ActivityLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateActivityLogDto} createActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerCreate: async (createActivityLogDto: CreateActivityLogDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createActivityLogDto' is not null or undefined
            assertParamExists('activityLogControllerCreate', 'createActivityLogDto', createActivityLogDto)
            const localVarPath = `/api/v1/activity-log/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createActivityLogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteActivityLogDto} deleteActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerDelete: async (deleteActivityLogDto: DeleteActivityLogDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteActivityLogDto' is not null or undefined
            assertParamExists('activityLogControllerDelete', 'deleteActivityLogDto', deleteActivityLogDto)
            const localVarPath = `/api/v1/activity-log/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteActivityLogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditActivityLogDto} editActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerEdit: async (editActivityLogDto: EditActivityLogDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editActivityLogDto' is not null or undefined
            assertParamExists('activityLogControllerEdit', 'editActivityLogDto', editActivityLogDto)
            const localVarPath = `/api/v1/activity-log/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editActivityLogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activity-log/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityLogApi - functional programming interface
 * @export
 */
export const ActivityLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateActivityLogDto} createActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activityLogControllerCreate(createActivityLogDto: CreateActivityLogDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activityLogControllerCreate(createActivityLogDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.activityLogControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteActivityLogDto} deleteActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activityLogControllerDelete(deleteActivityLogDto: DeleteActivityLogDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activityLogControllerDelete(deleteActivityLogDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.activityLogControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditActivityLogDto} editActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activityLogControllerEdit(editActivityLogDto: EditActivityLogDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activityLogControllerEdit(editActivityLogDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.activityLogControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activityLogControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activityLogControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.activityLogControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityLogApi - factory interface
 * @export
 */
export const ActivityLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityLogApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateActivityLogDto} createActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerCreate(createActivityLogDto: CreateActivityLogDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.activityLogControllerCreate(createActivityLogDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteActivityLogDto} deleteActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerDelete(deleteActivityLogDto: DeleteActivityLogDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.activityLogControllerDelete(deleteActivityLogDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditActivityLogDto} editActivityLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerEdit(editActivityLogDto: EditActivityLogDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.activityLogControllerEdit(editActivityLogDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityLogControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.activityLogControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityLogApi - object-oriented interface
 * @export
 * @class ActivityLogApi
 * @extends {BaseAPI}
 */
export class ActivityLogApi extends BaseAPI {
    /**
     * 
     * @param {CreateActivityLogDto} createActivityLogDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public activityLogControllerCreate(createActivityLogDto: CreateActivityLogDto, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).activityLogControllerCreate(createActivityLogDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteActivityLogDto} deleteActivityLogDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public activityLogControllerDelete(deleteActivityLogDto: DeleteActivityLogDto, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).activityLogControllerDelete(deleteActivityLogDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditActivityLogDto} editActivityLogDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public activityLogControllerEdit(editActivityLogDto: EditActivityLogDto, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).activityLogControllerEdit(editActivityLogDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public activityLogControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).activityLogControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SigninUserRequestDto} signinUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerAuthenticate: async (signinUserRequestDto: SigninUserRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signinUserRequestDto' is not null or undefined
            assertParamExists('authenticationControllerAuthenticate', 'signinUserRequestDto', signinUserRequestDto)
            const localVarPath = `/api/v1/authentication/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signinUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerIntrospect: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/authentication/instrospect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerRefresh: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/authentication/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerRefreshRenew: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/authentication/refresh/renew`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SigninUserRequestDto} signinUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationControllerAuthenticate(signinUserRequestDto: SigninUserRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationControllerAuthenticate201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationControllerAuthenticate(signinUserRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationControllerAuthenticate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationControllerIntrospect(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationControllerIntrospect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationControllerIntrospect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationControllerRefresh(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationControllerAuthenticate201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationControllerRefresh(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationControllerRefresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationControllerRefreshRenew(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationControllerRefreshRenew201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationControllerRefreshRenew(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationControllerRefreshRenew']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {SigninUserRequestDto} signinUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerAuthenticate(signinUserRequestDto: SigninUserRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationControllerAuthenticate201Response> {
            return localVarFp.authenticationControllerAuthenticate(signinUserRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerIntrospect(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.authenticationControllerIntrospect(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerRefresh(options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationControllerAuthenticate201Response> {
            return localVarFp.authenticationControllerRefresh(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerRefreshRenew(options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationControllerRefreshRenew201Response> {
            return localVarFp.authenticationControllerRefreshRenew(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @param {SigninUserRequestDto} signinUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationControllerAuthenticate(signinUserRequestDto: SigninUserRequestDto, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationControllerAuthenticate(signinUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationControllerIntrospect(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationControllerIntrospect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationControllerRefresh(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationControllerRefresh(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationControllerRefreshRenew(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationControllerRefreshRenew(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignApi - axios parameter creator
 * @export
 */
export const CampaignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaign/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCampaignDto} campaign 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerCreate: async (campaign: CreateCampaignDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('campaignControllerCreate', 'campaign', campaign)
            const localVarPath = `/api/v1/campaign/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (campaign !== undefined) { 
                localVarFormParams.append('campaign', JSON.stringify(campaign));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteCampaignDto} deleteCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerDelete: async (deleteCampaignDto: DeleteCampaignDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteCampaignDto' is not null or undefined
            assertParamExists('campaignControllerDelete', 'deleteCampaignDto', deleteCampaignDto)
            const localVarPath = `/api/v1/campaign/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditCampaignDto} campaign 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerEdit: async (campaign: EditCampaignDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('campaignControllerEdit', 'campaign', campaign)
            const localVarPath = `/api/v1/campaign/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (campaign !== undefined) { 
                localVarFormParams.append('campaign', JSON.stringify(campaign));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/campaign/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignApi - functional programming interface
 * @export
 */
export const CampaignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.campaignControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCampaignDto} campaign 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerCreate(campaign: CreateCampaignDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerCreate(campaign, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.campaignControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteCampaignDto} deleteCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerDelete(deleteCampaignDto: DeleteCampaignDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerDelete(deleteCampaignDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.campaignControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditCampaignDto} campaign 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerEdit(campaign: EditCampaignDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerEdit(campaign, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.campaignControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.campaignControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignApi - factory interface
 * @export
 */
export const CampaignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.campaignControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCampaignDto} campaign 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerCreate(campaign: CreateCampaignDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.campaignControllerCreate(campaign, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteCampaignDto} deleteCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerDelete(deleteCampaignDto: DeleteCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.campaignControllerDelete(deleteCampaignDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditCampaignDto} campaign 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerEdit(campaign: EditCampaignDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.campaignControllerEdit(campaign, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignControllerGet200Response> {
            return localVarFp.campaignControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignApi - object-oriented interface
 * @export
 * @class CampaignApi
 * @extends {BaseAPI}
 */
export class CampaignApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public campaignControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).campaignControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCampaignDto} campaign 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public campaignControllerCreate(campaign: CreateCampaignDto, file?: File, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).campaignControllerCreate(campaign, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteCampaignDto} deleteCampaignDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public campaignControllerDelete(deleteCampaignDto: DeleteCampaignDto, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).campaignControllerDelete(deleteCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditCampaignDto} campaign 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public campaignControllerEdit(campaign: EditCampaignDto, file?: File, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).campaignControllerEdit(campaign, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public campaignControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).campaignControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CardSeriesApi - axios parameter creator
 * @export
 */
export const CardSeriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ActivateCardSeriesDto} activateCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerActivate: async (activateCardSeriesDto: ActivateCardSeriesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activateCardSeriesDto' is not null or undefined
            assertParamExists('cardSeriesControllerActivate', 'activateCardSeriesDto', activateCardSeriesDto)
            const localVarPath = `/api/v1/card-series/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateCardSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActivateCardSeriesByPinDto} activateCardSeriesByPinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerActivateByPin: async (activateCardSeriesByPinDto: ActivateCardSeriesByPinDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activateCardSeriesByPinDto' is not null or undefined
            assertParamExists('cardSeriesControllerActivateByPin', 'activateCardSeriesByPinDto', activateCardSeriesByPinDto)
            const localVarPath = `/api/v1/card-series/activate-by-pin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateCardSeriesByPinDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/card-series/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AutoAssignCardSeriesDto} autoAssignCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerAutoAssign: async (autoAssignCardSeriesDto: AutoAssignCardSeriesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoAssignCardSeriesDto' is not null or undefined
            assertParamExists('cardSeriesControllerAutoAssign', 'autoAssignCardSeriesDto', autoAssignCardSeriesDto)
            const localVarPath = `/api/v1/card-series/auto-assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoAssignCardSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteCardSeriesDto} deleteCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerDelete: async (deleteCardSeriesDto: DeleteCardSeriesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteCardSeriesDto' is not null or undefined
            assertParamExists('cardSeriesControllerDelete', 'deleteCardSeriesDto', deleteCardSeriesDto)
            const localVarPath = `/api/v1/card-series/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCardSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExtendCardSeriesDto} extendCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerExtend: async (extendCardSeriesDto: ExtendCardSeriesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extendCardSeriesDto' is not null or undefined
            assertParamExists('cardSeriesControllerExtend', 'extendCardSeriesDto', extendCardSeriesDto)
            const localVarPath = `/api/v1/card-series/extend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendCardSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateCardSeriesDto} generateCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerGenerate: async (generateCardSeriesDto: GenerateCardSeriesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateCardSeriesDto' is not null or undefined
            assertParamExists('cardSeriesControllerGenerate', 'generateCardSeriesDto', generateCardSeriesDto)
            const localVarPath = `/api/v1/card-series/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCardSeriesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/card-series/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetNicknameDto} setNicknameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerSetNickname: async (setNicknameDto: SetNicknameDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setNicknameDto' is not null or undefined
            assertParamExists('cardSeriesControllerSetNickname', 'setNicknameDto', setNicknameDto)
            const localVarPath = `/api/v1/card-series/set-nickname`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNicknameDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardSeriesApi - functional programming interface
 * @export
 */
export const CardSeriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardSeriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ActivateCardSeriesDto} activateCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerActivate(activateCardSeriesDto: ActivateCardSeriesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerActivate(activateCardSeriesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerActivate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActivateCardSeriesByPinDto} activateCardSeriesByPinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerActivateByPin(activateCardSeriesByPinDto: ActivateCardSeriesByPinDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerActivateByPin(activateCardSeriesByPinDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerActivateByPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AutoAssignCardSeriesDto} autoAssignCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerAutoAssign(autoAssignCardSeriesDto: AutoAssignCardSeriesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerAutoAssign(autoAssignCardSeriesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerAutoAssign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteCardSeriesDto} deleteCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerDelete(deleteCardSeriesDto: DeleteCardSeriesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerDelete(deleteCardSeriesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExtendCardSeriesDto} extendCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerExtend(extendCardSeriesDto: ExtendCardSeriesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerExtend(extendCardSeriesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerExtend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateCardSeriesDto} generateCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerGenerate(generateCardSeriesDto: GenerateCardSeriesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerGenerate(generateCardSeriesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerGenerate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardSeriesControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetNicknameDto} setNicknameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardSeriesControllerSetNickname(setNicknameDto: SetNicknameDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardSeriesControllerSetNickname(setNicknameDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSeriesApi.cardSeriesControllerSetNickname']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CardSeriesApi - factory interface
 * @export
 */
export const CardSeriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardSeriesApiFp(configuration)
    return {
        /**
         * 
         * @param {ActivateCardSeriesDto} activateCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerActivate(activateCardSeriesDto: ActivateCardSeriesDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerActivate(activateCardSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ActivateCardSeriesByPinDto} activateCardSeriesByPinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerActivateByPin(activateCardSeriesByPinDto: ActivateCardSeriesByPinDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerActivateByPin(activateCardSeriesByPinDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.cardSeriesControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutoAssignCardSeriesDto} autoAssignCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerAutoAssign(autoAssignCardSeriesDto: AutoAssignCardSeriesDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerAutoAssign(autoAssignCardSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteCardSeriesDto} deleteCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerDelete(deleteCardSeriesDto: DeleteCardSeriesDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerDelete(deleteCardSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExtendCardSeriesDto} extendCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerExtend(extendCardSeriesDto: ExtendCardSeriesDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerExtend(extendCardSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateCardSeriesDto} generateCardSeriesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerGenerate(generateCardSeriesDto: GenerateCardSeriesDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerGenerate(generateCardSeriesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<CardSeriesControllerGet200Response> {
            return localVarFp.cardSeriesControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetNicknameDto} setNicknameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardSeriesControllerSetNickname(setNicknameDto: SetNicknameDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.cardSeriesControllerSetNickname(setNicknameDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CardSeriesApi - object-oriented interface
 * @export
 * @class CardSeriesApi
 * @extends {BaseAPI}
 */
export class CardSeriesApi extends BaseAPI {
    /**
     * 
     * @param {ActivateCardSeriesDto} activateCardSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerActivate(activateCardSeriesDto: ActivateCardSeriesDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerActivate(activateCardSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ActivateCardSeriesByPinDto} activateCardSeriesByPinDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerActivateByPin(activateCardSeriesByPinDto: ActivateCardSeriesByPinDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerActivateByPin(activateCardSeriesByPinDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutoAssignCardSeriesDto} autoAssignCardSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerAutoAssign(autoAssignCardSeriesDto: AutoAssignCardSeriesDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerAutoAssign(autoAssignCardSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteCardSeriesDto} deleteCardSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerDelete(deleteCardSeriesDto: DeleteCardSeriesDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerDelete(deleteCardSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExtendCardSeriesDto} extendCardSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerExtend(extendCardSeriesDto: ExtendCardSeriesDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerExtend(extendCardSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateCardSeriesDto} generateCardSeriesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerGenerate(generateCardSeriesDto: GenerateCardSeriesDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerGenerate(generateCardSeriesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetNicknameDto} setNicknameDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSeriesApi
     */
    public cardSeriesControllerSetNickname(setNicknameDto: SetNicknameDto, options?: RawAxiosRequestConfig) {
        return CardSeriesApiFp(this.configuration).cardSeriesControllerSetNickname(setNicknameDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceAuthorizationApi - axios parameter creator
 * @export
 */
export const DeviceAuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeviceAuthorization} deviceAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRegistrationControllerRegister: async (deviceAuthorization: DeviceAuthorization, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceAuthorization' is not null or undefined
            assertParamExists('deviceRegistrationControllerRegister', 'deviceAuthorization', deviceAuthorization)
            const localVarPath = `/device/authorization/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceAuthorization, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceAuthorizationApi - functional programming interface
 * @export
 */
export const DeviceAuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceAuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeviceAuthorization} deviceAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceRegistrationControllerRegister(deviceAuthorization: DeviceAuthorization, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceRegistrationControllerRegister201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceRegistrationControllerRegister(deviceAuthorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceAuthorizationApi.deviceRegistrationControllerRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceAuthorizationApi - factory interface
 * @export
 */
export const DeviceAuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceAuthorizationApiFp(configuration)
    return {
        /**
         * 
         * @param {DeviceAuthorization} deviceAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRegistrationControllerRegister(deviceAuthorization: DeviceAuthorization, options?: RawAxiosRequestConfig): AxiosPromise<DeviceRegistrationControllerRegister201Response> {
            return localVarFp.deviceRegistrationControllerRegister(deviceAuthorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceAuthorizationApi - object-oriented interface
 * @export
 * @class DeviceAuthorizationApi
 * @extends {BaseAPI}
 */
export class DeviceAuthorizationApi extends BaseAPI {
    /**
     * 
     * @param {DeviceAuthorization} deviceAuthorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAuthorizationApi
     */
    public deviceRegistrationControllerRegister(deviceAuthorization: DeviceAuthorization, options?: RawAxiosRequestConfig) {
        return DeviceAuthorizationApiFp(this.configuration).deviceRegistrationControllerRegister(deviceAuthorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GoogleCloudStorageApi - axios parameter creator
 * @export
 */
export const GoogleCloudStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} filepath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudStorageControllerGetImage: async (filepath: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filepath' is not null or undefined
            assertParamExists('cloudStorageControllerGetImage', 'filepath', filepath)
            const localVarPath = `/api/v1/cloud/storage/asset/{filepath}`
                .replace(`{${"filepath"}}`, encodeURIComponent(String(filepath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudStorageControllerGetSampleAssets: async (params: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'params' is not null or undefined
            assertParamExists('cloudStorageControllerGetSampleAssets', 'params', params)
            const localVarPath = `/api/v1/cloud/storage/sample/{params}`
                .replace(`{${"params"}}`, encodeURIComponent(String(params)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudStorageControllerUploadMedia: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('cloudStorageControllerUploadMedia', 'file', file)
            const localVarPath = `/api/v1/cloud/storage/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoogleCloudStorageApi - functional programming interface
 * @export
 */
export const GoogleCloudStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoogleCloudStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} filepath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudStorageControllerGetImage(filepath: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudStorageControllerGetImage(filepath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCloudStorageApi.cloudStorageControllerGetImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudStorageControllerGetSampleAssets(params: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudStorageControllerGetSampleAssets(params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCloudStorageApi.cloudStorageControllerGetSampleAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudStorageControllerUploadMedia(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudStorageControllerUploadMedia(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCloudStorageApi.cloudStorageControllerUploadMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoogleCloudStorageApi - factory interface
 * @export
 */
export const GoogleCloudStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoogleCloudStorageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} filepath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudStorageControllerGetImage(filepath: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.cloudStorageControllerGetImage(filepath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudStorageControllerGetSampleAssets(params: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cloudStorageControllerGetSampleAssets(params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudStorageControllerUploadMedia(file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cloudStorageControllerUploadMedia(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoogleCloudStorageApi - object-oriented interface
 * @export
 * @class GoogleCloudStorageApi
 * @extends {BaseAPI}
 */
export class GoogleCloudStorageApi extends BaseAPI {
    /**
     * 
     * @param {string} filepath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCloudStorageApi
     */
    public cloudStorageControllerGetImage(filepath: string, options?: RawAxiosRequestConfig) {
        return GoogleCloudStorageApiFp(this.configuration).cloudStorageControllerGetImage(filepath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCloudStorageApi
     */
    public cloudStorageControllerGetSampleAssets(params: string, options?: RawAxiosRequestConfig) {
        return GoogleCloudStorageApiFp(this.configuration).cloudStorageControllerGetSampleAssets(params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCloudStorageApi
     */
    public cloudStorageControllerUploadMedia(file: File, options?: RawAxiosRequestConfig) {
        return GoogleCloudStorageApiFp(this.configuration).cloudStorageControllerUploadMedia(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LedgerApi - axios parameter creator
 * @export
 */
export const LedgerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ledger/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLedgerDto} createLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerCreate: async (createLedgerDto: CreateLedgerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLedgerDto' is not null or undefined
            assertParamExists('ledgerControllerCreate', 'createLedgerDto', createLedgerDto)
            const localVarPath = `/api/v1/ledger/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLedgerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteLedgerDto} deleteLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerDelete: async (deleteLedgerDto: DeleteLedgerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteLedgerDto' is not null or undefined
            assertParamExists('ledgerControllerDelete', 'deleteLedgerDto', deleteLedgerDto)
            const localVarPath = `/api/v1/ledger/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLedgerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditLedgerDto} editLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerEdit: async (editLedgerDto: EditLedgerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editLedgerDto' is not null or undefined
            assertParamExists('ledgerControllerEdit', 'editLedgerDto', editLedgerDto)
            const localVarPath = `/api/v1/ledger/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editLedgerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ledger/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LedgerApi - functional programming interface
 * @export
 */
export const LedgerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LedgerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ledgerControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ledgerControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LedgerApi.ledgerControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateLedgerDto} createLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ledgerControllerCreate(createLedgerDto: CreateLedgerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ledgerControllerCreate(createLedgerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LedgerApi.ledgerControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteLedgerDto} deleteLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ledgerControllerDelete(deleteLedgerDto: DeleteLedgerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ledgerControllerDelete(deleteLedgerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LedgerApi.ledgerControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditLedgerDto} editLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ledgerControllerEdit(editLedgerDto: EditLedgerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ledgerControllerEdit(editLedgerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LedgerApi.ledgerControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ledgerControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LedgerControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ledgerControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LedgerApi.ledgerControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LedgerApi - factory interface
 * @export
 */
export const LedgerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LedgerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.ledgerControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLedgerDto} createLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerCreate(createLedgerDto: CreateLedgerDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.ledgerControllerCreate(createLedgerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteLedgerDto} deleteLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerDelete(deleteLedgerDto: DeleteLedgerDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.ledgerControllerDelete(deleteLedgerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditLedgerDto} editLedgerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerEdit(editLedgerDto: EditLedgerDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.ledgerControllerEdit(editLedgerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledgerControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<LedgerControllerGet200Response> {
            return localVarFp.ledgerControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LedgerApi - object-oriented interface
 * @export
 * @class LedgerApi
 * @extends {BaseAPI}
 */
export class LedgerApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public ledgerControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).ledgerControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLedgerDto} createLedgerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public ledgerControllerCreate(createLedgerDto: CreateLedgerDto, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).ledgerControllerCreate(createLedgerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteLedgerDto} deleteLedgerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public ledgerControllerDelete(deleteLedgerDto: DeleteLedgerDto, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).ledgerControllerDelete(deleteLedgerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditLedgerDto} editLedgerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public ledgerControllerEdit(editLedgerDto: EditLedgerDto, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).ledgerControllerEdit(editLedgerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public ledgerControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).ledgerControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PersonApi - axios parameter creator
 * @export
 */
export const PersonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/person/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerAttachFile: async (code: string, attachmentType: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('personControllerAttachFile', 'code', code)
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('personControllerAttachFile', 'attachmentType', attachmentType)
            const localVarPath = `/api/v1/person/attach-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (code !== undefined) { 
                localVarFormParams.append('code', code as any);
            }
    
            if (attachmentType !== undefined) { 
                localVarFormParams.append('attachment_type', attachmentType as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BlockPersonDto} blockPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerBlock: async (blockPersonDto: BlockPersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blockPersonDto' is not null or undefined
            assertParamExists('personControllerBlock', 'blockPersonDto', blockPersonDto)
            const localVarPath = `/api/v1/person/block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockPersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerCreate: async (person: CreatePersonExtendedDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'person' is not null or undefined
            assertParamExists('personControllerCreate', 'person', person)
            const localVarPath = `/api/v1/person/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (person !== undefined) { 
                localVarFormParams.append('person', JSON.stringify(person));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerCustomer: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/person/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePersonDto} deletePersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerDelete: async (deletePersonDto: DeletePersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deletePersonDto' is not null or undefined
            assertParamExists('personControllerDelete', 'deletePersonDto', deletePersonDto)
            const localVarPath = `/api/v1/person/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditPersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerEdit: async (person: EditPersonExtendedDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'person' is not null or undefined
            assertParamExists('personControllerEdit', 'person', person)
            const localVarPath = `/api/v1/person/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (person !== undefined) { 
                localVarFormParams.append('person', JSON.stringify(person));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/person/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerRegister: async (person: CreatePersonExtendedDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'person' is not null or undefined
            assertParamExists('personControllerRegister', 'person', person)
            const localVarPath = `/api/v1/person/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (person !== undefined) { 
                localVarFormParams.append('person', JSON.stringify(person));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerStaff: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/person/staff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnlockPersonDto} unlockPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerUnlock: async (unlockPersonDto: UnlockPersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unlockPersonDto' is not null or undefined
            assertParamExists('personControllerUnlock', 'unlockPersonDto', unlockPersonDto)
            const localVarPath = `/api/v1/person/unlock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unlockPersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonApi - functional programming interface
 * @export
 */
export const PersonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerAttachFile(code: string, attachmentType: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerAttachFile(code, attachmentType, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerAttachFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BlockPersonDto} blockPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerBlock(blockPersonDto: BlockPersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerBlock(blockPersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerBlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerCreate(person: CreatePersonExtendedDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerCreate(person, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerCustomer(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerCustomer(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeletePersonDto} deletePersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerDelete(deletePersonDto: DeletePersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerDelete(deletePersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditPersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerEdit(person: EditPersonExtendedDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerEdit(person, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerRegister(person: CreatePersonExtendedDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerRegister(person, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerStaff(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerStaff(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UnlockPersonDto} unlockPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personControllerUnlock(unlockPersonDto: UnlockPersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personControllerUnlock(unlockPersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonApi.personControllerUnlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersonApi - factory interface
 * @export
 */
export const PersonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.personControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerAttachFile(code: string, attachmentType: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerAttachFile(code, attachmentType, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BlockPersonDto} blockPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerBlock(blockPersonDto: BlockPersonDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerBlock(blockPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerCreate(person: CreatePersonExtendedDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerCreate(person, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerCustomer(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerGet200Response> {
            return localVarFp.personControllerCustomer(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePersonDto} deletePersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerDelete(deletePersonDto: DeletePersonDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerDelete(deletePersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditPersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerEdit(person: EditPersonExtendedDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerEdit(person, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerGet200Response> {
            return localVarFp.personControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePersonExtendedDto} person 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerRegister(person: CreatePersonExtendedDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerRegister(person, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerStaff(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerGet200Response> {
            return localVarFp.personControllerStaff(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnlockPersonDto} unlockPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personControllerUnlock(unlockPersonDto: UnlockPersonDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personControllerUnlock(unlockPersonDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonApi - object-oriented interface
 * @export
 * @class PersonApi
 * @extends {BaseAPI}
 */
export class PersonApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerAttachFile(code: string, attachmentType: string, file?: File, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerAttachFile(code, attachmentType, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BlockPersonDto} blockPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerBlock(blockPersonDto: BlockPersonDto, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerBlock(blockPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePersonExtendedDto} person 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerCreate(person: CreatePersonExtendedDto, file?: File, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerCreate(person, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerCustomer(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerCustomer(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePersonDto} deletePersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerDelete(deletePersonDto: DeletePersonDto, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerDelete(deletePersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditPersonExtendedDto} person 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerEdit(person: EditPersonExtendedDto, file?: File, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerEdit(person, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePersonExtendedDto} person 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerRegister(person: CreatePersonExtendedDto, file?: File, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerRegister(person, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerStaff(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerStaff(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnlockPersonDto} unlockPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    public personControllerUnlock(unlockPersonDto: UnlockPersonDto, options?: RawAxiosRequestConfig) {
        return PersonApiFp(this.configuration).personControllerUnlock(unlockPersonDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PersonAddressApi - axios parameter creator
 * @export
 */
export const PersonAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/person-address/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePersonAddressDto} createPersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerCreate: async (createPersonAddressDto: CreatePersonAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPersonAddressDto' is not null or undefined
            assertParamExists('personAddressControllerCreate', 'createPersonAddressDto', createPersonAddressDto)
            const localVarPath = `/api/v1/person-address/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePersonAddressDto} deletePersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerDelete: async (deletePersonAddressDto: DeletePersonAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deletePersonAddressDto' is not null or undefined
            assertParamExists('personAddressControllerDelete', 'deletePersonAddressDto', deletePersonAddressDto)
            const localVarPath = `/api/v1/person-address/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePersonAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditPersonAddressDto} editPersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerEdit: async (editPersonAddressDto: EditPersonAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editPersonAddressDto' is not null or undefined
            assertParamExists('personAddressControllerEdit', 'editPersonAddressDto', editPersonAddressDto)
            const localVarPath = `/api/v1/person-address/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editPersonAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/person-address/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonAddressApi - functional programming interface
 * @export
 */
export const PersonAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personAddressControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personAddressControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonAddressApi.personAddressControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePersonAddressDto} createPersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personAddressControllerCreate(createPersonAddressDto: CreatePersonAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personAddressControllerCreate(createPersonAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonAddressApi.personAddressControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeletePersonAddressDto} deletePersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personAddressControllerDelete(deletePersonAddressDto: DeletePersonAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personAddressControllerDelete(deletePersonAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonAddressApi.personAddressControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditPersonAddressDto} editPersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personAddressControllerEdit(editPersonAddressDto: EditPersonAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personAddressControllerEdit(editPersonAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonAddressApi.personAddressControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personAddressControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonAddressControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personAddressControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonAddressApi.personAddressControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersonAddressApi - factory interface
 * @export
 */
export const PersonAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonAddressApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.personAddressControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePersonAddressDto} createPersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerCreate(createPersonAddressDto: CreatePersonAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personAddressControllerCreate(createPersonAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePersonAddressDto} deletePersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerDelete(deletePersonAddressDto: DeletePersonAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personAddressControllerDelete(deletePersonAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditPersonAddressDto} editPersonAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerEdit(editPersonAddressDto: EditPersonAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.personAddressControllerEdit(editPersonAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAddressControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonAddressControllerGet200Response> {
            return localVarFp.personAddressControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonAddressApi - object-oriented interface
 * @export
 * @class PersonAddressApi
 * @extends {BaseAPI}
 */
export class PersonAddressApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonAddressApi
     */
    public personAddressControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return PersonAddressApiFp(this.configuration).personAddressControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePersonAddressDto} createPersonAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonAddressApi
     */
    public personAddressControllerCreate(createPersonAddressDto: CreatePersonAddressDto, options?: RawAxiosRequestConfig) {
        return PersonAddressApiFp(this.configuration).personAddressControllerCreate(createPersonAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePersonAddressDto} deletePersonAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonAddressApi
     */
    public personAddressControllerDelete(deletePersonAddressDto: DeletePersonAddressDto, options?: RawAxiosRequestConfig) {
        return PersonAddressApiFp(this.configuration).personAddressControllerDelete(deletePersonAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditPersonAddressDto} editPersonAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonAddressApi
     */
    public personAddressControllerEdit(editPersonAddressDto: EditPersonAddressDto, options?: RawAxiosRequestConfig) {
        return PersonAddressApiFp(this.configuration).personAddressControllerEdit(editPersonAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonAddressApi
     */
    public personAddressControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return PersonAddressApiFp(this.configuration).personAddressControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegistrationApi - axios parameter creator
 * @export
 */
export const RegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/registration/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRegistrationDto} registration 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerCreate: async (registration: CreateRegistrationDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registration' is not null or undefined
            assertParamExists('registrationControllerCreate', 'registration', registration)
            const localVarPath = `/api/v1/registration/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (registration !== undefined) { 
                localVarFormParams.append('registration', JSON.stringify(registration));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteRegistrationDto} deleteRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerDelete: async (deleteRegistrationDto: DeleteRegistrationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteRegistrationDto' is not null or undefined
            assertParamExists('registrationControllerDelete', 'deleteRegistrationDto', deleteRegistrationDto)
            const localVarPath = `/api/v1/registration/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRegistrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/registration/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProcessRegistrationDto} processRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerProceed: async (processRegistrationDto: ProcessRegistrationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processRegistrationDto' is not null or undefined
            assertParamExists('registrationControllerProceed', 'processRegistrationDto', processRegistrationDto)
            const localVarPath = `/api/v1/registration/proceed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processRegistrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationApi - functional programming interface
 * @export
 */
export const RegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registrationControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRegistrationDto} registration 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationControllerCreate(registration: CreateRegistrationDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationControllerCreate(registration, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registrationControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteRegistrationDto} deleteRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationControllerDelete(deleteRegistrationDto: DeleteRegistrationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationControllerDelete(deleteRegistrationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registrationControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registrationControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProcessRegistrationDto} processRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationControllerProceed(processRegistrationDto: ProcessRegistrationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationControllerProceed(processRegistrationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registrationControllerProceed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegistrationApi - factory interface
 * @export
 */
export const RegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.registrationControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRegistrationDto} registration 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerCreate(registration: CreateRegistrationDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.registrationControllerCreate(registration, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteRegistrationDto} deleteRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerDelete(deleteRegistrationDto: DeleteRegistrationDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.registrationControllerDelete(deleteRegistrationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<RegistrationControllerGet200Response> {
            return localVarFp.registrationControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProcessRegistrationDto} processRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationControllerProceed(processRegistrationDto: ProcessRegistrationDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.registrationControllerProceed(processRegistrationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
export class RegistrationApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registrationControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registrationControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRegistrationDto} registration 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registrationControllerCreate(registration: CreateRegistrationDto, file?: File, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registrationControllerCreate(registration, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteRegistrationDto} deleteRegistrationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registrationControllerDelete(deleteRegistrationDto: DeleteRegistrationDto, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registrationControllerDelete(deleteRegistrationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registrationControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registrationControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProcessRegistrationDto} processRegistrationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registrationControllerProceed(processRegistrationDto: ProcessRegistrationDto, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registrationControllerProceed(processRegistrationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerAgeRange: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/age-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerBirthday: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/birthday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerCampaign: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerCardStats: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/card-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerEarnPoints: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/earn-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerEarnStamp: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/earn-stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerRank: async (limit?: number, offset?: number, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/rank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerRedeemPoints: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/redeem-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerRedeemStamp: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/redeem-stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerTransaction: async (dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerAgeRange(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerAgeRange(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerAgeRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerBirthday(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerBirthday200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerBirthday(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerBirthday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerCampaign(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerCampaign(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerCardStats(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerCardStats(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerCardStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerEarnPoints(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerEarnPoints(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerEarnPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerEarnStamp(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerEarnStamp(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerEarnStamp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerRank(limit?: number, offset?: number, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerRank200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerRank(limit, offset, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerRank']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerRedeemPoints(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerRedeemPoints(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerRedeemPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerRedeemStamp(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerCardStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerRedeemStamp(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerRedeemStamp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerTransaction(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerTransaction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerTransaction(dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.reportControllerTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerAgeRange(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerAgeRange(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerBirthday(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerBirthday200Response> {
            return localVarFp.reportControllerBirthday(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerCampaign(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerCampaign(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerCardStats(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerCardStats(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerEarnPoints(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerEarnPoints(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerEarnStamp(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerEarnStamp(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerRank(limit?: number, offset?: number, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerRank200Response> {
            return localVarFp.reportControllerRank(limit, offset, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerRedeemPoints(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerRedeemPoints(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerRedeemStamp(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerCardStats200Response> {
            return localVarFp.reportControllerRedeemStamp(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerTransaction(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportControllerTransaction200Response> {
            return localVarFp.reportControllerTransaction(dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerAgeRange(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerAgeRange(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerBirthday(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerBirthday(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerCampaign(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerCampaign(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerCardStats(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerCardStats(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerEarnPoints(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerEarnPoints(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerEarnStamp(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerEarnStamp(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerRank(limit?: number, offset?: number, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerRank(limit, offset, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerRedeemPoints(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerRedeemPoints(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerRedeemStamp(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerRedeemStamp(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerTransaction(dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerTransaction(dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RequestApi - axios parameter creator
 * @export
 */
export const RequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/request/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRequestDto} createRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestControllerCreate: async (createRequestDto: CreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRequestDto' is not null or undefined
            assertParamExists('requestControllerCreate', 'createRequestDto', createRequestDto)
            const localVarPath = `/api/v1/request/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/request/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestApi - functional programming interface
 * @export
 */
export const RequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestApi.requestControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRequestDto} createRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestControllerCreate(createRequestDto: CreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestControllerCreate(createRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestApi.requestControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestApi.requestControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequestApi - factory interface
 * @export
 */
export const RequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.requestControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRequestDto} createRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestControllerCreate(createRequestDto: CreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.requestControllerCreate(createRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestControllerGet200Response> {
            return localVarFp.requestControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestApi - object-oriented interface
 * @export
 * @class RequestApi
 * @extends {BaseAPI}
 */
export class RequestApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestApi
     */
    public requestControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RequestApiFp(this.configuration).requestControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRequestDto} createRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestApi
     */
    public requestControllerCreate(createRequestDto: CreateRequestDto, options?: RawAxiosRequestConfig) {
        return RequestApiFp(this.configuration).requestControllerCreate(createRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestApi
     */
    public requestControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RequestApiFp(this.configuration).requestControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RewardApi - axios parameter creator
 * @export
 */
export const RewardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reward/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerBalance: async (code: string, tenant?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('rewardControllerBalance', 'code', code)
            const localVarPath = `/api/v1/reward/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerCampaign: async (code: string, tenant?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('rewardControllerCampaign', 'code', code)
            const localVarPath = `/api/v1/reward/campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRewardDto} createRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerCreate: async (createRewardDto: CreateRewardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRewardDto' is not null or undefined
            assertParamExists('rewardControllerCreate', 'createRewardDto', createRewardDto)
            const localVarPath = `/api/v1/reward/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRewardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteRewardDto} deleteRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerDelete: async (deleteRewardDto: DeleteRewardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteRewardDto' is not null or undefined
            assertParamExists('rewardControllerDelete', 'deleteRewardDto', deleteRewardDto)
            const localVarPath = `/api/v1/reward/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRewardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EarnRewardDto} earnRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerEarn: async (earnRewardDto: EarnRewardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'earnRewardDto' is not null or undefined
            assertParamExists('rewardControllerEarn', 'earnRewardDto', earnRewardDto)
            const localVarPath = `/api/v1/reward/earn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(earnRewardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditRewardDto} editRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerEdit: async (editRewardDto: EditRewardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editRewardDto' is not null or undefined
            assertParamExists('rewardControllerEdit', 'editRewardDto', editRewardDto)
            const localVarPath = `/api/v1/reward/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRewardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reward/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerMembers: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reward/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RedeemRewardDto} redeemRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerRedeem: async (redeemRewardDto: RedeemRewardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemRewardDto' is not null or undefined
            assertParamExists('rewardControllerRedeem', 'redeemRewardDto', redeemRewardDto)
            const localVarPath = `/api/v1/reward/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemRewardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RedeemRewardDto} redeemRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerRedeemV2: async (redeemRewardDto: RedeemRewardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemRewardDto' is not null or undefined
            assertParamExists('rewardControllerRedeemV2', 'redeemRewardDto', redeemRewardDto)
            const localVarPath = `/api/v1/reward/redeem-v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemRewardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerUserBalance: async (code: string, tenant?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('rewardControllerUserBalance', 'code', code)
            const localVarPath = `/api/v1/reward/user-balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardApi - functional programming interface
 * @export
 */
export const RewardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerBalance(code: string, tenant?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerBalance(code, tenant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerCampaign(code: string, tenant?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardControllerCampaign200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerCampaign(code, tenant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRewardDto} createRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerCreate(createRewardDto: CreateRewardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerCreate(createRewardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteRewardDto} deleteRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerDelete(deleteRewardDto: DeleteRewardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerDelete(deleteRewardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EarnRewardDto} earnRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerEarn(earnRewardDto: EarnRewardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerEarn(earnRewardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerEarn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditRewardDto} editRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerEdit(editRewardDto: EditRewardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerEdit(editRewardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerMembers(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardControllerMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerMembers(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RedeemRewardDto} redeemRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerRedeem(redeemRewardDto: RedeemRewardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerRedeem(redeemRewardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerRedeem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RedeemRewardDto} redeemRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerRedeemV2(redeemRewardDto: RedeemRewardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerRedeemV2(redeemRewardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerRedeemV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardControllerUserBalance(code: string, tenant?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardControllerUserBalance(code, tenant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.rewardControllerUserBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardApi - factory interface
 * @export
 */
export const RewardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.rewardControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerBalance(code: string, tenant?: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerBalance(code, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerCampaign(code: string, tenant?: string, options?: RawAxiosRequestConfig): AxiosPromise<RewardControllerCampaign200Response> {
            return localVarFp.rewardControllerCampaign(code, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRewardDto} createRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerCreate(createRewardDto: CreateRewardDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerCreate(createRewardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteRewardDto} deleteRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerDelete(deleteRewardDto: DeleteRewardDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerDelete(deleteRewardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EarnRewardDto} earnRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerEarn(earnRewardDto: EarnRewardDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerEarn(earnRewardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditRewardDto} editRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerEdit(editRewardDto: EditRewardDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerEdit(editRewardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<RewardControllerGet200Response> {
            return localVarFp.rewardControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerMembers(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<RewardControllerMembers200Response> {
            return localVarFp.rewardControllerMembers(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RedeemRewardDto} redeemRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerRedeem(redeemRewardDto: RedeemRewardDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerRedeem(redeemRewardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RedeemRewardDto} redeemRewardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerRedeemV2(redeemRewardDto: RedeemRewardDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerRedeemV2(redeemRewardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} [tenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardControllerUserBalance(code: string, tenant?: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardControllerUserBalance(code, tenant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardApi - object-oriented interface
 * @export
 * @class RewardApi
 * @extends {BaseAPI}
 */
export class RewardApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} [tenant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerBalance(code: string, tenant?: string, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerBalance(code, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} [tenant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerCampaign(code: string, tenant?: string, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerCampaign(code, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRewardDto} createRewardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerCreate(createRewardDto: CreateRewardDto, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerCreate(createRewardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteRewardDto} deleteRewardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerDelete(deleteRewardDto: DeleteRewardDto, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerDelete(deleteRewardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EarnRewardDto} earnRewardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerEarn(earnRewardDto: EarnRewardDto, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerEarn(earnRewardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditRewardDto} editRewardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerEdit(editRewardDto: EditRewardDto, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerEdit(editRewardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerMembers(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerMembers(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RedeemRewardDto} redeemRewardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerRedeem(redeemRewardDto: RedeemRewardDto, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerRedeem(redeemRewardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RedeemRewardDto} redeemRewardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerRedeemV2(redeemRewardDto: RedeemRewardDto, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerRedeemV2(redeemRewardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} [tenant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public rewardControllerUserBalance(code: string, tenant?: string, options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).rewardControllerUserBalance(code, tenant, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RewardEventApi - axios parameter creator
 * @export
 */
export const RewardEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reward-event/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRewardEventDto} createRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerCreate: async (createRewardEventDto: CreateRewardEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRewardEventDto' is not null or undefined
            assertParamExists('rewardEventControllerCreate', 'createRewardEventDto', createRewardEventDto)
            const localVarPath = `/api/v1/reward-event/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRewardEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteRewardEventDto} deleteRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerDelete: async (deleteRewardEventDto: DeleteRewardEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteRewardEventDto' is not null or undefined
            assertParamExists('rewardEventControllerDelete', 'deleteRewardEventDto', deleteRewardEventDto)
            const localVarPath = `/api/v1/reward-event/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRewardEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditRewardEventDto} editRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerEdit: async (editRewardEventDto: EditRewardEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editRewardEventDto' is not null or undefined
            assertParamExists('rewardEventControllerEdit', 'editRewardEventDto', editRewardEventDto)
            const localVarPath = `/api/v1/reward-event/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRewardEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reward-event/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardEventApi - functional programming interface
 * @export
 */
export const RewardEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardEventControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardEventControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardEventApi.rewardEventControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRewardEventDto} createRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardEventControllerCreate(createRewardEventDto: CreateRewardEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardEventControllerCreate(createRewardEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardEventApi.rewardEventControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteRewardEventDto} deleteRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardEventControllerDelete(deleteRewardEventDto: DeleteRewardEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardEventControllerDelete(deleteRewardEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardEventApi.rewardEventControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditRewardEventDto} editRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardEventControllerEdit(editRewardEventDto: EditRewardEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardEventControllerEdit(editRewardEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardEventApi.rewardEventControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardEventControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardEventControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardEventControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardEventApi.rewardEventControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardEventApi - factory interface
 * @export
 */
export const RewardEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardEventApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.rewardEventControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRewardEventDto} createRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerCreate(createRewardEventDto: CreateRewardEventDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardEventControllerCreate(createRewardEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteRewardEventDto} deleteRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerDelete(deleteRewardEventDto: DeleteRewardEventDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardEventControllerDelete(deleteRewardEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditRewardEventDto} editRewardEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerEdit(editRewardEventDto: EditRewardEventDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.rewardEventControllerEdit(editRewardEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardEventControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<RewardEventControllerGet200Response> {
            return localVarFp.rewardEventControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardEventApi - object-oriented interface
 * @export
 * @class RewardEventApi
 * @extends {BaseAPI}
 */
export class RewardEventApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardEventApi
     */
    public rewardEventControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RewardEventApiFp(this.configuration).rewardEventControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRewardEventDto} createRewardEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardEventApi
     */
    public rewardEventControllerCreate(createRewardEventDto: CreateRewardEventDto, options?: RawAxiosRequestConfig) {
        return RewardEventApiFp(this.configuration).rewardEventControllerCreate(createRewardEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteRewardEventDto} deleteRewardEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardEventApi
     */
    public rewardEventControllerDelete(deleteRewardEventDto: DeleteRewardEventDto, options?: RawAxiosRequestConfig) {
        return RewardEventApiFp(this.configuration).rewardEventControllerDelete(deleteRewardEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditRewardEventDto} editRewardEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardEventApi
     */
    public rewardEventControllerEdit(editRewardEventDto: EditRewardEventDto, options?: RawAxiosRequestConfig) {
        return RewardEventApiFp(this.configuration).rewardEventControllerEdit(editRewardEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardEventApi
     */
    public rewardEventControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return RewardEventApiFp(this.configuration).rewardEventControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerControllerNoClockout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/scheduler/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerControllerNoClockout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerControllerNoClockout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.schedulerControllerNoClockout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerControllerNoClockout(options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.schedulerControllerNoClockout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerControllerNoClockout(options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerControllerNoClockout(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerAttachFile: async (code: string, attachmentType: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('tenantControllerAttachFile', 'code', code)
            // verify required parameter 'attachmentType' is not null or undefined
            assertParamExists('tenantControllerAttachFile', 'attachmentType', attachmentType)
            const localVarPath = `/api/v1/tenant/attach-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (code !== undefined) { 
                localVarFormParams.append('code', code as any);
            }
    
            if (attachmentType !== undefined) { 
                localVarFormParams.append('attachment_type', attachmentType as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTenantDto} createTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerCreate: async (createTenantDto: CreateTenantDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTenantDto' is not null or undefined
            assertParamExists('tenantControllerCreate', 'createTenantDto', createTenantDto)
            const localVarPath = `/api/v1/tenant/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteTenantDto} deleteTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerDelete: async (deleteTenantDto: DeleteTenantDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteTenantDto' is not null or undefined
            assertParamExists('tenantControllerDelete', 'deleteTenantDto', deleteTenantDto)
            const localVarPath = `/api/v1/tenant/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditTenantDto} editTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerEdit: async (editTenantDto: EditTenantDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editTenantDto' is not null or undefined
            assertParamExists('tenantControllerEdit', 'editTenantDto', editTenantDto)
            const localVarPath = `/api/v1/tenant/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerGetBySlug: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('tenantControllerGetBySlug', 'slug', slug)
            const localVarPath = `/api/v1/tenant/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerAttachFile(code: string, attachmentType: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerAttachFile(code, attachmentType, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerAttachFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTenantDto} createTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerCreate(createTenantDto: CreateTenantDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerCreate(createTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteTenantDto} deleteTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerDelete(deleteTenantDto: DeleteTenantDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerDelete(deleteTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditTenantDto} editTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerEdit(editTenantDto: EditTenantDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerEdit(editTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantControllerGetBySlug(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantControllerGetBySlug(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.tenantControllerGetBySlug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.tenantControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerAttachFile(code: string, attachmentType: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.tenantControllerAttachFile(code, attachmentType, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTenantDto} createTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerCreate(createTenantDto: CreateTenantDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.tenantControllerCreate(createTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteTenantDto} deleteTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerDelete(deleteTenantDto: DeleteTenantDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.tenantControllerDelete(deleteTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditTenantDto} editTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerEdit(editTenantDto: EditTenantDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.tenantControllerEdit(editTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<TenantControllerGet200Response> {
            return localVarFp.tenantControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerGetBySlug(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTenantDto> {
            return localVarFp.tenantControllerGetBySlug(slug, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerAttachFile(code: string, attachmentType: string, file?: File, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerAttachFile(code, attachmentType, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTenantDto} createTenantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerCreate(createTenantDto: CreateTenantDto, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerCreate(createTenantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteTenantDto} deleteTenantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerDelete(deleteTenantDto: DeleteTenantDto, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerDelete(deleteTenantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditTenantDto} editTenantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerEdit(editTenantDto: EditTenantDto, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerEdit(editTenantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public tenantControllerGetBySlug(slug: string, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).tenantControllerGetBySlug(slug, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateTransactionDto} createTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerCreate: async (createTransactionDto: CreateTransactionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTransactionDto' is not null or undefined
            assertParamExists('transactionControllerCreate', 'createTransactionDto', createTransactionDto)
            const localVarPath = `/api/v1/transaction/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteTransactionDto} deleteTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerDelete: async (deleteTransactionDto: DeleteTransactionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteTransactionDto' is not null or undefined
            assertParamExists('transactionControllerDelete', 'deleteTransactionDto', deleteTransactionDto)
            const localVarPath = `/api/v1/transaction/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditTransactionDto} editTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerEdit: async (editTransactionDto: EditTransactionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editTransactionDto' is not null or undefined
            assertParamExists('transactionControllerEdit', 'editTransactionDto', editTransactionDto)
            const localVarPath = `/api/v1/transaction/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transaction/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VoidTransactionDto} voidTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerVoid: async (voidTransactionDto: VoidTransactionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voidTransactionDto' is not null or undefined
            assertParamExists('transactionControllerVoid', 'voidTransactionDto', voidTransactionDto)
            const localVarPath = `/api/v1/transaction/void`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voidTransactionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateTransactionDto} createTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionControllerCreate(createTransactionDto: CreateTransactionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionControllerCreate(createTransactionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.transactionControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteTransactionDto} deleteTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionControllerDelete(deleteTransactionDto: DeleteTransactionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionControllerDelete(deleteTransactionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.transactionControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditTransactionDto} editTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionControllerEdit(editTransactionDto: EditTransactionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionControllerEdit(editTransactionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.transactionControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.transactionControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VoidTransactionDto} voidTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionControllerVoid(voidTransactionDto: VoidTransactionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionControllerVoid(voidTransactionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.transactionControllerVoid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateTransactionDto} createTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerCreate(createTransactionDto: CreateTransactionDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.transactionControllerCreate(createTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteTransactionDto} deleteTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerDelete(deleteTransactionDto: DeleteTransactionDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.transactionControllerDelete(deleteTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditTransactionDto} editTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerEdit(editTransactionDto: EditTransactionDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.transactionControllerEdit(editTransactionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionControllerGet200Response> {
            return localVarFp.transactionControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VoidTransactionDto} voidTransactionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionControllerVoid(voidTransactionDto: VoidTransactionDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.transactionControllerVoid(voidTransactionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @param {CreateTransactionDto} createTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionControllerCreate(createTransactionDto: CreateTransactionDto, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionControllerCreate(createTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteTransactionDto} deleteTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionControllerDelete(deleteTransactionDto: DeleteTransactionDto, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionControllerDelete(deleteTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditTransactionDto} editTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionControllerEdit(editTransactionDto: EditTransactionDto, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionControllerEdit(editTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VoidTransactionDto} voidTransactionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionControllerVoid(voidTransactionDto: VoidTransactionDto, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionControllerVoid(voidTransactionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityAttachmentTypeApi - axios parameter creator
 * @export
 */
export const UtilityAttachmentTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-attachment-type/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAttachmentTypeDto} createAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerCreate: async (createAttachmentTypeDto: CreateAttachmentTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAttachmentTypeDto' is not null or undefined
            assertParamExists('utilAttachmentTypeControllerCreate', 'createAttachmentTypeDto', createAttachmentTypeDto)
            const localVarPath = `/api/v1/util-attachment-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAttachmentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerDelete: async (deleteAttachmentTypeDto: DeleteAttachmentTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAttachmentTypeDto' is not null or undefined
            assertParamExists('utilAttachmentTypeControllerDelete', 'deleteAttachmentTypeDto', deleteAttachmentTypeDto)
            const localVarPath = `/api/v1/util-attachment-type/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAttachmentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditAttachmentTypeDto} editAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerEdit: async (editAttachmentTypeDto: EditAttachmentTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editAttachmentTypeDto' is not null or undefined
            assertParamExists('utilAttachmentTypeControllerEdit', 'editAttachmentTypeDto', editAttachmentTypeDto)
            const localVarPath = `/api/v1/util-attachment-type/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editAttachmentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-attachment-type/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityAttachmentTypeApi - functional programming interface
 * @export
 */
export const UtilityAttachmentTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityAttachmentTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilAttachmentTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilAttachmentTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityAttachmentTypeApi.utilAttachmentTypeControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAttachmentTypeDto} createAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilAttachmentTypeControllerCreate(createAttachmentTypeDto: CreateAttachmentTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityAttachmentTypeApi.utilAttachmentTypeControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto: DeleteAttachmentTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityAttachmentTypeApi.utilAttachmentTypeControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditAttachmentTypeDto} editAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilAttachmentTypeControllerEdit(editAttachmentTypeDto: EditAttachmentTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityAttachmentTypeApi.utilAttachmentTypeControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilAttachmentTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilAttachmentTypeControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilAttachmentTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityAttachmentTypeApi.utilAttachmentTypeControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityAttachmentTypeApi - factory interface
 * @export
 */
export const UtilityAttachmentTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityAttachmentTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilAttachmentTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateAttachmentTypeDto} createAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerCreate(createAttachmentTypeDto: CreateAttachmentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto: DeleteAttachmentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditAttachmentTypeDto} editAttachmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerEdit(editAttachmentTypeDto: EditAttachmentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilAttachmentTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilAttachmentTypeControllerGet200Response> {
            return localVarFp.utilAttachmentTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityAttachmentTypeApi - object-oriented interface
 * @export
 * @class UtilityAttachmentTypeApi
 * @extends {BaseAPI}
 */
export class UtilityAttachmentTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityAttachmentTypeApi
     */
    public utilAttachmentTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityAttachmentTypeApiFp(this.configuration).utilAttachmentTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityAttachmentTypeApi
     */
    public utilAttachmentTypeControllerCreate(createAttachmentTypeDto: CreateAttachmentTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityAttachmentTypeApiFp(this.configuration).utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityAttachmentTypeApi
     */
    public utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto: DeleteAttachmentTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityAttachmentTypeApiFp(this.configuration).utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityAttachmentTypeApi
     */
    public utilAttachmentTypeControllerEdit(editAttachmentTypeDto: EditAttachmentTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityAttachmentTypeApiFp(this.configuration).utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityAttachmentTypeApi
     */
    public utilAttachmentTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityAttachmentTypeApiFp(this.configuration).utilAttachmentTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityBranchApi - axios parameter creator
 * @export
 */
export const UtilityBranchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-branch/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBranchDto} createBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerCreate: async (createBranchDto: CreateBranchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBranchDto' is not null or undefined
            assertParamExists('utilBranchControllerCreate', 'createBranchDto', createBranchDto)
            const localVarPath = `/api/v1/util-branch/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBranchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteBranchDto} deleteBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerDelete: async (deleteBranchDto: DeleteBranchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteBranchDto' is not null or undefined
            assertParamExists('utilBranchControllerDelete', 'deleteBranchDto', deleteBranchDto)
            const localVarPath = `/api/v1/util-branch/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBranchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditBranchDto} editBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerEdit: async (editBranchDto: EditBranchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editBranchDto' is not null or undefined
            assertParamExists('utilBranchControllerEdit', 'editBranchDto', editBranchDto)
            const localVarPath = `/api/v1/util-branch/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editBranchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-branch/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityBranchApi - functional programming interface
 * @export
 */
export const UtilityBranchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityBranchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilBranchControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilBranchControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityBranchApi.utilBranchControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBranchDto} createBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilBranchControllerCreate(createBranchDto: CreateBranchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilBranchControllerCreate(createBranchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityBranchApi.utilBranchControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteBranchDto} deleteBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilBranchControllerDelete(deleteBranchDto: DeleteBranchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilBranchControllerDelete(deleteBranchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityBranchApi.utilBranchControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditBranchDto} editBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilBranchControllerEdit(editBranchDto: EditBranchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilBranchControllerEdit(editBranchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityBranchApi.utilBranchControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilBranchControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilBranchControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilBranchControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityBranchApi.utilBranchControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityBranchApi - factory interface
 * @export
 */
export const UtilityBranchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityBranchApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilBranchControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateBranchDto} createBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerCreate(createBranchDto: CreateBranchDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilBranchControllerCreate(createBranchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteBranchDto} deleteBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerDelete(deleteBranchDto: DeleteBranchDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilBranchControllerDelete(deleteBranchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditBranchDto} editBranchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerEdit(editBranchDto: EditBranchDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilBranchControllerEdit(editBranchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilBranchControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilBranchControllerGet200Response> {
            return localVarFp.utilBranchControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityBranchApi - object-oriented interface
 * @export
 * @class UtilityBranchApi
 * @extends {BaseAPI}
 */
export class UtilityBranchApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityBranchApi
     */
    public utilBranchControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityBranchApiFp(this.configuration).utilBranchControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateBranchDto} createBranchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityBranchApi
     */
    public utilBranchControllerCreate(createBranchDto: CreateBranchDto, options?: RawAxiosRequestConfig) {
        return UtilityBranchApiFp(this.configuration).utilBranchControllerCreate(createBranchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteBranchDto} deleteBranchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityBranchApi
     */
    public utilBranchControllerDelete(deleteBranchDto: DeleteBranchDto, options?: RawAxiosRequestConfig) {
        return UtilityBranchApiFp(this.configuration).utilBranchControllerDelete(deleteBranchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditBranchDto} editBranchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityBranchApi
     */
    public utilBranchControllerEdit(editBranchDto: EditBranchDto, options?: RawAxiosRequestConfig) {
        return UtilityBranchApiFp(this.configuration).utilBranchControllerEdit(editBranchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityBranchApi
     */
    public utilBranchControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityBranchApiFp(this.configuration).utilBranchControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityCardCategoryApi - axios parameter creator
 * @export
 */
export const UtilityCardCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-card-category/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCardCategoryDto} createCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerCreate: async (createCardCategoryDto: CreateCardCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCardCategoryDto' is not null or undefined
            assertParamExists('utilCardCategoryControllerCreate', 'createCardCategoryDto', createCardCategoryDto)
            const localVarPath = `/api/v1/util-card-category/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCardCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteCardCategoryDto} deleteCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerDelete: async (deleteCardCategoryDto: DeleteCardCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteCardCategoryDto' is not null or undefined
            assertParamExists('utilCardCategoryControllerDelete', 'deleteCardCategoryDto', deleteCardCategoryDto)
            const localVarPath = `/api/v1/util-card-category/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCardCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditCardCategoryDto} editCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerEdit: async (editCardCategoryDto: EditCardCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editCardCategoryDto' is not null or undefined
            assertParamExists('utilCardCategoryControllerEdit', 'editCardCategoryDto', editCardCategoryDto)
            const localVarPath = `/api/v1/util-card-category/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editCardCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-card-category/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityCardCategoryApi - functional programming interface
 * @export
 */
export const UtilityCardCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityCardCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCardCategoryControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCardCategoryControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCardCategoryApi.utilCardCategoryControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCardCategoryDto} createCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCardCategoryControllerCreate(createCardCategoryDto: CreateCardCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCardCategoryControllerCreate(createCardCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCardCategoryApi.utilCardCategoryControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteCardCategoryDto} deleteCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCardCategoryControllerDelete(deleteCardCategoryDto: DeleteCardCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCardCategoryControllerDelete(deleteCardCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCardCategoryApi.utilCardCategoryControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditCardCategoryDto} editCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCardCategoryControllerEdit(editCardCategoryDto: EditCardCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCardCategoryControllerEdit(editCardCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCardCategoryApi.utilCardCategoryControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCardCategoryControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilCardCategoryControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCardCategoryControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCardCategoryApi.utilCardCategoryControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityCardCategoryApi - factory interface
 * @export
 */
export const UtilityCardCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityCardCategoryApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilCardCategoryControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCardCategoryDto} createCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerCreate(createCardCategoryDto: CreateCardCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilCardCategoryControllerCreate(createCardCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteCardCategoryDto} deleteCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerDelete(deleteCardCategoryDto: DeleteCardCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilCardCategoryControllerDelete(deleteCardCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditCardCategoryDto} editCardCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerEdit(editCardCategoryDto: EditCardCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilCardCategoryControllerEdit(editCardCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCardCategoryControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilCardCategoryControllerGet200Response> {
            return localVarFp.utilCardCategoryControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityCardCategoryApi - object-oriented interface
 * @export
 * @class UtilityCardCategoryApi
 * @extends {BaseAPI}
 */
export class UtilityCardCategoryApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCardCategoryApi
     */
    public utilCardCategoryControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityCardCategoryApiFp(this.configuration).utilCardCategoryControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCardCategoryDto} createCardCategoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCardCategoryApi
     */
    public utilCardCategoryControllerCreate(createCardCategoryDto: CreateCardCategoryDto, options?: RawAxiosRequestConfig) {
        return UtilityCardCategoryApiFp(this.configuration).utilCardCategoryControllerCreate(createCardCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteCardCategoryDto} deleteCardCategoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCardCategoryApi
     */
    public utilCardCategoryControllerDelete(deleteCardCategoryDto: DeleteCardCategoryDto, options?: RawAxiosRequestConfig) {
        return UtilityCardCategoryApiFp(this.configuration).utilCardCategoryControllerDelete(deleteCardCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditCardCategoryDto} editCardCategoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCardCategoryApi
     */
    public utilCardCategoryControllerEdit(editCardCategoryDto: EditCardCategoryDto, options?: RawAxiosRequestConfig) {
        return UtilityCardCategoryApiFp(this.configuration).utilCardCategoryControllerEdit(editCardCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCardCategoryApi
     */
    public utilCardCategoryControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityCardCategoryApiFp(this.configuration).utilCardCategoryControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityConfigApi - axios parameter creator
 * @export
 */
export const UtilityConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-config/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateConfigDto} createConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerCreate: async (createConfigDto: CreateConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConfigDto' is not null or undefined
            assertParamExists('utilConfigControllerCreate', 'createConfigDto', createConfigDto)
            const localVarPath = `/api/v1/util-config/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteConfigDto} deleteConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerDelete: async (deleteConfigDto: DeleteConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteConfigDto' is not null or undefined
            assertParamExists('utilConfigControllerDelete', 'deleteConfigDto', deleteConfigDto)
            const localVarPath = `/api/v1/util-config/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditConfigDto} editConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerEdit: async (editConfigDto: EditConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editConfigDto' is not null or undefined
            assertParamExists('utilConfigControllerEdit', 'editConfigDto', editConfigDto)
            const localVarPath = `/api/v1/util-config/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-config/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityConfigApi - functional programming interface
 * @export
 */
export const UtilityConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilConfigControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilConfigControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityConfigApi.utilConfigControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateConfigDto} createConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilConfigControllerCreate(createConfigDto: CreateConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilConfigControllerCreate(createConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityConfigApi.utilConfigControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteConfigDto} deleteConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilConfigControllerDelete(deleteConfigDto: DeleteConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilConfigControllerDelete(deleteConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityConfigApi.utilConfigControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditConfigDto} editConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilConfigControllerEdit(editConfigDto: EditConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilConfigControllerEdit(editConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityConfigApi.utilConfigControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilConfigControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilConfigControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilConfigControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityConfigApi.utilConfigControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityConfigApi - factory interface
 * @export
 */
export const UtilityConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilConfigControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateConfigDto} createConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerCreate(createConfigDto: CreateConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilConfigControllerCreate(createConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteConfigDto} deleteConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerDelete(deleteConfigDto: DeleteConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilConfigControllerDelete(deleteConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditConfigDto} editConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerEdit(editConfigDto: EditConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilConfigControllerEdit(editConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilConfigControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilConfigControllerGet200Response> {
            return localVarFp.utilConfigControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityConfigApi - object-oriented interface
 * @export
 * @class UtilityConfigApi
 * @extends {BaseAPI}
 */
export class UtilityConfigApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityConfigApi
     */
    public utilConfigControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityConfigApiFp(this.configuration).utilConfigControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateConfigDto} createConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityConfigApi
     */
    public utilConfigControllerCreate(createConfigDto: CreateConfigDto, options?: RawAxiosRequestConfig) {
        return UtilityConfigApiFp(this.configuration).utilConfigControllerCreate(createConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteConfigDto} deleteConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityConfigApi
     */
    public utilConfigControllerDelete(deleteConfigDto: DeleteConfigDto, options?: RawAxiosRequestConfig) {
        return UtilityConfigApiFp(this.configuration).utilConfigControllerDelete(deleteConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditConfigDto} editConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityConfigApi
     */
    public utilConfigControllerEdit(editConfigDto: EditConfigDto, options?: RawAxiosRequestConfig) {
        return UtilityConfigApiFp(this.configuration).utilConfigControllerEdit(editConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityConfigApi
     */
    public utilConfigControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityConfigApiFp(this.configuration).utilConfigControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityCreditTypeApi - axios parameter creator
 * @export
 */
export const UtilityCreditTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-credit-type/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCreditTypeDto} createCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerCreate: async (createCreditTypeDto: CreateCreditTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCreditTypeDto' is not null or undefined
            assertParamExists('utilCreditTypeControllerCreate', 'createCreditTypeDto', createCreditTypeDto)
            const localVarPath = `/api/v1/util-credit-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCreditTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteCreditTypeDto} deleteCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerDelete: async (deleteCreditTypeDto: DeleteCreditTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteCreditTypeDto' is not null or undefined
            assertParamExists('utilCreditTypeControllerDelete', 'deleteCreditTypeDto', deleteCreditTypeDto)
            const localVarPath = `/api/v1/util-credit-type/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCreditTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditCreditTypeDto} editCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerEdit: async (editCreditTypeDto: EditCreditTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editCreditTypeDto' is not null or undefined
            assertParamExists('utilCreditTypeControllerEdit', 'editCreditTypeDto', editCreditTypeDto)
            const localVarPath = `/api/v1/util-credit-type/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editCreditTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-credit-type/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityCreditTypeApi - functional programming interface
 * @export
 */
export const UtilityCreditTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityCreditTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCreditTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCreditTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCreditTypeApi.utilCreditTypeControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCreditTypeDto} createCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCreditTypeControllerCreate(createCreditTypeDto: CreateCreditTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCreditTypeControllerCreate(createCreditTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCreditTypeApi.utilCreditTypeControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteCreditTypeDto} deleteCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCreditTypeControllerDelete(deleteCreditTypeDto: DeleteCreditTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCreditTypeControllerDelete(deleteCreditTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCreditTypeApi.utilCreditTypeControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditCreditTypeDto} editCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCreditTypeControllerEdit(editCreditTypeDto: EditCreditTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCreditTypeControllerEdit(editCreditTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCreditTypeApi.utilCreditTypeControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilCreditTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilCreditTypeControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilCreditTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityCreditTypeApi.utilCreditTypeControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityCreditTypeApi - factory interface
 * @export
 */
export const UtilityCreditTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityCreditTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilCreditTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCreditTypeDto} createCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerCreate(createCreditTypeDto: CreateCreditTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilCreditTypeControllerCreate(createCreditTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteCreditTypeDto} deleteCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerDelete(deleteCreditTypeDto: DeleteCreditTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilCreditTypeControllerDelete(deleteCreditTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditCreditTypeDto} editCreditTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerEdit(editCreditTypeDto: EditCreditTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilCreditTypeControllerEdit(editCreditTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilCreditTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilCreditTypeControllerGet200Response> {
            return localVarFp.utilCreditTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityCreditTypeApi - object-oriented interface
 * @export
 * @class UtilityCreditTypeApi
 * @extends {BaseAPI}
 */
export class UtilityCreditTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCreditTypeApi
     */
    public utilCreditTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityCreditTypeApiFp(this.configuration).utilCreditTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCreditTypeDto} createCreditTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCreditTypeApi
     */
    public utilCreditTypeControllerCreate(createCreditTypeDto: CreateCreditTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityCreditTypeApiFp(this.configuration).utilCreditTypeControllerCreate(createCreditTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteCreditTypeDto} deleteCreditTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCreditTypeApi
     */
    public utilCreditTypeControllerDelete(deleteCreditTypeDto: DeleteCreditTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityCreditTypeApiFp(this.configuration).utilCreditTypeControllerDelete(deleteCreditTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditCreditTypeDto} editCreditTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCreditTypeApi
     */
    public utilCreditTypeControllerEdit(editCreditTypeDto: EditCreditTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityCreditTypeApiFp(this.configuration).utilCreditTypeControllerEdit(editCreditTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityCreditTypeApi
     */
    public utilCreditTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityCreditTypeApiFp(this.configuration).utilCreditTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityDebitTypeApi - axios parameter creator
 * @export
 */
export const UtilityDebitTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-debit-type/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDebitTypeDto} createDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerCreate: async (createDebitTypeDto: CreateDebitTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDebitTypeDto' is not null or undefined
            assertParamExists('utilDebitTypeControllerCreate', 'createDebitTypeDto', createDebitTypeDto)
            const localVarPath = `/api/v1/util-debit-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDebitTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteDebitTypeDto} deleteDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerDelete: async (deleteDebitTypeDto: DeleteDebitTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteDebitTypeDto' is not null or undefined
            assertParamExists('utilDebitTypeControllerDelete', 'deleteDebitTypeDto', deleteDebitTypeDto)
            const localVarPath = `/api/v1/util-debit-type/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDebitTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditDebitTypeDto} editDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerEdit: async (editDebitTypeDto: EditDebitTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editDebitTypeDto' is not null or undefined
            assertParamExists('utilDebitTypeControllerEdit', 'editDebitTypeDto', editDebitTypeDto)
            const localVarPath = `/api/v1/util-debit-type/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editDebitTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-debit-type/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityDebitTypeApi - functional programming interface
 * @export
 */
export const UtilityDebitTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityDebitTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilDebitTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilDebitTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityDebitTypeApi.utilDebitTypeControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateDebitTypeDto} createDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilDebitTypeControllerCreate(createDebitTypeDto: CreateDebitTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilDebitTypeControllerCreate(createDebitTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityDebitTypeApi.utilDebitTypeControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteDebitTypeDto} deleteDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilDebitTypeControllerDelete(deleteDebitTypeDto: DeleteDebitTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilDebitTypeControllerDelete(deleteDebitTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityDebitTypeApi.utilDebitTypeControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditDebitTypeDto} editDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilDebitTypeControllerEdit(editDebitTypeDto: EditDebitTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilDebitTypeControllerEdit(editDebitTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityDebitTypeApi.utilDebitTypeControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilDebitTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilDebitTypeControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilDebitTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityDebitTypeApi.utilDebitTypeControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityDebitTypeApi - factory interface
 * @export
 */
export const UtilityDebitTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityDebitTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilDebitTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDebitTypeDto} createDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerCreate(createDebitTypeDto: CreateDebitTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilDebitTypeControllerCreate(createDebitTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteDebitTypeDto} deleteDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerDelete(deleteDebitTypeDto: DeleteDebitTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilDebitTypeControllerDelete(deleteDebitTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditDebitTypeDto} editDebitTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerEdit(editDebitTypeDto: EditDebitTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilDebitTypeControllerEdit(editDebitTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilDebitTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilDebitTypeControllerGet200Response> {
            return localVarFp.utilDebitTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityDebitTypeApi - object-oriented interface
 * @export
 * @class UtilityDebitTypeApi
 * @extends {BaseAPI}
 */
export class UtilityDebitTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityDebitTypeApi
     */
    public utilDebitTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityDebitTypeApiFp(this.configuration).utilDebitTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDebitTypeDto} createDebitTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityDebitTypeApi
     */
    public utilDebitTypeControllerCreate(createDebitTypeDto: CreateDebitTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityDebitTypeApiFp(this.configuration).utilDebitTypeControllerCreate(createDebitTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteDebitTypeDto} deleteDebitTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityDebitTypeApi
     */
    public utilDebitTypeControllerDelete(deleteDebitTypeDto: DeleteDebitTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityDebitTypeApiFp(this.configuration).utilDebitTypeControllerDelete(deleteDebitTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditDebitTypeDto} editDebitTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityDebitTypeApi
     */
    public utilDebitTypeControllerEdit(editDebitTypeDto: EditDebitTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityDebitTypeApiFp(this.configuration).utilDebitTypeControllerEdit(editDebitTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityDebitTypeApi
     */
    public utilDebitTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityDebitTypeApiFp(this.configuration).utilDebitTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityItemApi - axios parameter creator
 * @export
 */
export const UtilityItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-item/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateItemDto} createItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerCreate: async (createItemDto: CreateItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createItemDto' is not null or undefined
            assertParamExists('utilItemControllerCreate', 'createItemDto', createItemDto)
            const localVarPath = `/api/v1/util-item/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteItemDto} deleteItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerDelete: async (deleteItemDto: DeleteItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteItemDto' is not null or undefined
            assertParamExists('utilItemControllerDelete', 'deleteItemDto', deleteItemDto)
            const localVarPath = `/api/v1/util-item/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditItemDto} editItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerEdit: async (editItemDto: EditItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editItemDto' is not null or undefined
            assertParamExists('utilItemControllerEdit', 'editItemDto', editItemDto)
            const localVarPath = `/api/v1/util-item/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-item/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityItemApi - functional programming interface
 * @export
 */
export const UtilityItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilItemControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilItemControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityItemApi.utilItemControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateItemDto} createItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilItemControllerCreate(createItemDto: CreateItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilItemControllerCreate(createItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityItemApi.utilItemControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteItemDto} deleteItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilItemControllerDelete(deleteItemDto: DeleteItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilItemControllerDelete(deleteItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityItemApi.utilItemControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditItemDto} editItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilItemControllerEdit(editItemDto: EditItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilItemControllerEdit(editItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityItemApi.utilItemControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilItemControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilItemControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilItemControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityItemApi.utilItemControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityItemApi - factory interface
 * @export
 */
export const UtilityItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityItemApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilItemControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateItemDto} createItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerCreate(createItemDto: CreateItemDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilItemControllerCreate(createItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteItemDto} deleteItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerDelete(deleteItemDto: DeleteItemDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilItemControllerDelete(deleteItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditItemDto} editItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerEdit(editItemDto: EditItemDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilItemControllerEdit(editItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilItemControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilItemControllerGet200Response> {
            return localVarFp.utilItemControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityItemApi - object-oriented interface
 * @export
 * @class UtilityItemApi
 * @extends {BaseAPI}
 */
export class UtilityItemApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityItemApi
     */
    public utilItemControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityItemApiFp(this.configuration).utilItemControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateItemDto} createItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityItemApi
     */
    public utilItemControllerCreate(createItemDto: CreateItemDto, options?: RawAxiosRequestConfig) {
        return UtilityItemApiFp(this.configuration).utilItemControllerCreate(createItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteItemDto} deleteItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityItemApi
     */
    public utilItemControllerDelete(deleteItemDto: DeleteItemDto, options?: RawAxiosRequestConfig) {
        return UtilityItemApiFp(this.configuration).utilItemControllerDelete(deleteItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditItemDto} editItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityItemApi
     */
    public utilItemControllerEdit(editItemDto: EditItemDto, options?: RawAxiosRequestConfig) {
        return UtilityItemApiFp(this.configuration).utilItemControllerEdit(editItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityItemApi
     */
    public utilItemControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityItemApiFp(this.configuration).utilItemControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityLevelApi - axios parameter creator
 * @export
 */
export const UtilityLevelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-level/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLevelDto} level 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerCreate: async (level: CreateLevelDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'level' is not null or undefined
            assertParamExists('utilLevelControllerCreate', 'level', level)
            const localVarPath = `/api/v1/util-level/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (level !== undefined) { 
                localVarFormParams.append('level', JSON.stringify(level));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteLevelDto} deleteLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerDelete: async (deleteLevelDto: DeleteLevelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteLevelDto' is not null or undefined
            assertParamExists('utilLevelControllerDelete', 'deleteLevelDto', deleteLevelDto)
            const localVarPath = `/api/v1/util-level/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLevelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditLevelDto} level 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerEdit: async (level: EditLevelDto, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'level' is not null or undefined
            assertParamExists('utilLevelControllerEdit', 'level', level)
            const localVarPath = `/api/v1/util-level/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (level !== undefined) { 
                localVarFormParams.append('level', JSON.stringify(level));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-level/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityLevelApi - functional programming interface
 * @export
 */
export const UtilityLevelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityLevelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilLevelControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilLevelControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityLevelApi.utilLevelControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateLevelDto} level 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilLevelControllerCreate(level: CreateLevelDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilLevelControllerCreate(level, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityLevelApi.utilLevelControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteLevelDto} deleteLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilLevelControllerDelete(deleteLevelDto: DeleteLevelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilLevelControllerDelete(deleteLevelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityLevelApi.utilLevelControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditLevelDto} level 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilLevelControllerEdit(level: EditLevelDto, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilLevelControllerEdit(level, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityLevelApi.utilLevelControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilLevelControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilLevelControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilLevelControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityLevelApi.utilLevelControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityLevelApi - factory interface
 * @export
 */
export const UtilityLevelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityLevelApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilLevelControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLevelDto} level 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerCreate(level: CreateLevelDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilLevelControllerCreate(level, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteLevelDto} deleteLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerDelete(deleteLevelDto: DeleteLevelDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilLevelControllerDelete(deleteLevelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditLevelDto} level 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerEdit(level: EditLevelDto, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilLevelControllerEdit(level, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilLevelControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilLevelControllerGet200Response> {
            return localVarFp.utilLevelControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityLevelApi - object-oriented interface
 * @export
 * @class UtilityLevelApi
 * @extends {BaseAPI}
 */
export class UtilityLevelApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityLevelApi
     */
    public utilLevelControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityLevelApiFp(this.configuration).utilLevelControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLevelDto} level 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityLevelApi
     */
    public utilLevelControllerCreate(level: CreateLevelDto, file?: File, options?: RawAxiosRequestConfig) {
        return UtilityLevelApiFp(this.configuration).utilLevelControllerCreate(level, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteLevelDto} deleteLevelDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityLevelApi
     */
    public utilLevelControllerDelete(deleteLevelDto: DeleteLevelDto, options?: RawAxiosRequestConfig) {
        return UtilityLevelApiFp(this.configuration).utilLevelControllerDelete(deleteLevelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditLevelDto} level 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityLevelApi
     */
    public utilLevelControllerEdit(level: EditLevelDto, file?: File, options?: RawAxiosRequestConfig) {
        return UtilityLevelApiFp(this.configuration).utilLevelControllerEdit(level, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityLevelApi
     */
    public utilLevelControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityLevelApiFp(this.configuration).utilLevelControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityRequestTypeApi - axios parameter creator
 * @export
 */
export const UtilityRequestTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-request-type/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRequestTypeDto} createRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerCreate: async (createRequestTypeDto: CreateRequestTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRequestTypeDto' is not null or undefined
            assertParamExists('utilRequestTypeControllerCreate', 'createRequestTypeDto', createRequestTypeDto)
            const localVarPath = `/api/v1/util-request-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRequestTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteRequestTypeDto} deleteRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerDelete: async (deleteRequestTypeDto: DeleteRequestTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteRequestTypeDto' is not null or undefined
            assertParamExists('utilRequestTypeControllerDelete', 'deleteRequestTypeDto', deleteRequestTypeDto)
            const localVarPath = `/api/v1/util-request-type/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequestTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditRequestTypeDto} editRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerEdit: async (editRequestTypeDto: EditRequestTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editRequestTypeDto' is not null or undefined
            assertParamExists('utilRequestTypeControllerEdit', 'editRequestTypeDto', editRequestTypeDto)
            const localVarPath = `/api/v1/util-request-type/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRequestTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-request-type/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityRequestTypeApi - functional programming interface
 * @export
 */
export const UtilityRequestTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityRequestTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRequestTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRequestTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRequestTypeApi.utilRequestTypeControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRequestTypeDto} createRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRequestTypeControllerCreate(createRequestTypeDto: CreateRequestTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRequestTypeControllerCreate(createRequestTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRequestTypeApi.utilRequestTypeControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteRequestTypeDto} deleteRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRequestTypeControllerDelete(deleteRequestTypeDto: DeleteRequestTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRequestTypeControllerDelete(deleteRequestTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRequestTypeApi.utilRequestTypeControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditRequestTypeDto} editRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRequestTypeControllerEdit(editRequestTypeDto: EditRequestTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRequestTypeControllerEdit(editRequestTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRequestTypeApi.utilRequestTypeControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRequestTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilRequestTypeControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRequestTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRequestTypeApi.utilRequestTypeControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityRequestTypeApi - factory interface
 * @export
 */
export const UtilityRequestTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityRequestTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilRequestTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRequestTypeDto} createRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerCreate(createRequestTypeDto: CreateRequestTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRequestTypeControllerCreate(createRequestTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteRequestTypeDto} deleteRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerDelete(deleteRequestTypeDto: DeleteRequestTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRequestTypeControllerDelete(deleteRequestTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditRequestTypeDto} editRequestTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerEdit(editRequestTypeDto: EditRequestTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRequestTypeControllerEdit(editRequestTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRequestTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilRequestTypeControllerGet200Response> {
            return localVarFp.utilRequestTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityRequestTypeApi - object-oriented interface
 * @export
 * @class UtilityRequestTypeApi
 * @extends {BaseAPI}
 */
export class UtilityRequestTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRequestTypeApi
     */
    public utilRequestTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityRequestTypeApiFp(this.configuration).utilRequestTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRequestTypeDto} createRequestTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRequestTypeApi
     */
    public utilRequestTypeControllerCreate(createRequestTypeDto: CreateRequestTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityRequestTypeApiFp(this.configuration).utilRequestTypeControllerCreate(createRequestTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteRequestTypeDto} deleteRequestTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRequestTypeApi
     */
    public utilRequestTypeControllerDelete(deleteRequestTypeDto: DeleteRequestTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityRequestTypeApiFp(this.configuration).utilRequestTypeControllerDelete(deleteRequestTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditRequestTypeDto} editRequestTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRequestTypeApi
     */
    public utilRequestTypeControllerEdit(editRequestTypeDto: EditRequestTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityRequestTypeApiFp(this.configuration).utilRequestTypeControllerEdit(editRequestTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRequestTypeApi
     */
    public utilRequestTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityRequestTypeApiFp(this.configuration).utilRequestTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityRewardTypeApi - axios parameter creator
 * @export
 */
export const UtilityRewardTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-reward-type/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRewardTypeDto} createRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerCreate: async (createRewardTypeDto: CreateRewardTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRewardTypeDto' is not null or undefined
            assertParamExists('utilRewardTypeControllerCreate', 'createRewardTypeDto', createRewardTypeDto)
            const localVarPath = `/api/v1/util-reward-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRewardTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteRewardTypeDto} deleteRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerDelete: async (deleteRewardTypeDto: DeleteRewardTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteRewardTypeDto' is not null or undefined
            assertParamExists('utilRewardTypeControllerDelete', 'deleteRewardTypeDto', deleteRewardTypeDto)
            const localVarPath = `/api/v1/util-reward-type/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRewardTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditRewardTypeDto} editRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerEdit: async (editRewardTypeDto: EditRewardTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editRewardTypeDto' is not null or undefined
            assertParamExists('utilRewardTypeControllerEdit', 'editRewardTypeDto', editRewardTypeDto)
            const localVarPath = `/api/v1/util-reward-type/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRewardTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-reward-type/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityRewardTypeApi - functional programming interface
 * @export
 */
export const UtilityRewardTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityRewardTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRewardTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRewardTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRewardTypeApi.utilRewardTypeControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRewardTypeDto} createRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRewardTypeControllerCreate(createRewardTypeDto: CreateRewardTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRewardTypeControllerCreate(createRewardTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRewardTypeApi.utilRewardTypeControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteRewardTypeDto} deleteRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRewardTypeControllerDelete(deleteRewardTypeDto: DeleteRewardTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRewardTypeControllerDelete(deleteRewardTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRewardTypeApi.utilRewardTypeControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditRewardTypeDto} editRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRewardTypeControllerEdit(editRewardTypeDto: EditRewardTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRewardTypeControllerEdit(editRewardTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRewardTypeApi.utilRewardTypeControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRewardTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilRewardTypeControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRewardTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRewardTypeApi.utilRewardTypeControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityRewardTypeApi - factory interface
 * @export
 */
export const UtilityRewardTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityRewardTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilRewardTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRewardTypeDto} createRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerCreate(createRewardTypeDto: CreateRewardTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRewardTypeControllerCreate(createRewardTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteRewardTypeDto} deleteRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerDelete(deleteRewardTypeDto: DeleteRewardTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRewardTypeControllerDelete(deleteRewardTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditRewardTypeDto} editRewardTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerEdit(editRewardTypeDto: EditRewardTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRewardTypeControllerEdit(editRewardTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRewardTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilRewardTypeControllerGet200Response> {
            return localVarFp.utilRewardTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityRewardTypeApi - object-oriented interface
 * @export
 * @class UtilityRewardTypeApi
 * @extends {BaseAPI}
 */
export class UtilityRewardTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRewardTypeApi
     */
    public utilRewardTypeControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityRewardTypeApiFp(this.configuration).utilRewardTypeControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRewardTypeDto} createRewardTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRewardTypeApi
     */
    public utilRewardTypeControllerCreate(createRewardTypeDto: CreateRewardTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityRewardTypeApiFp(this.configuration).utilRewardTypeControllerCreate(createRewardTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteRewardTypeDto} deleteRewardTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRewardTypeApi
     */
    public utilRewardTypeControllerDelete(deleteRewardTypeDto: DeleteRewardTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityRewardTypeApiFp(this.configuration).utilRewardTypeControllerDelete(deleteRewardTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditRewardTypeDto} editRewardTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRewardTypeApi
     */
    public utilRewardTypeControllerEdit(editRewardTypeDto: EditRewardTypeDto, options?: RawAxiosRequestConfig) {
        return UtilityRewardTypeApiFp(this.configuration).utilRewardTypeControllerEdit(editRewardTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRewardTypeApi
     */
    public utilRewardTypeControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityRewardTypeApiFp(this.configuration).utilRewardTypeControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityRoleApi - axios parameter creator
 * @export
 */
export const UtilityRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-role/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerCreate: async (createRoleDto: CreateRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('utilRoleControllerCreate', 'createRoleDto', createRoleDto)
            const localVarPath = `/api/v1/util-role/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteRoleDto} deleteRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerDelete: async (deleteRoleDto: DeleteRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteRoleDto' is not null or undefined
            assertParamExists('utilRoleControllerDelete', 'deleteRoleDto', deleteRoleDto)
            const localVarPath = `/api/v1/util-role/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditRoleDto} editRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerEdit: async (editRoleDto: EditRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editRoleDto' is not null or undefined
            assertParamExists('utilRoleControllerEdit', 'editRoleDto', editRoleDto)
            const localVarPath = `/api/v1/util-role/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-role/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityRoleApi - functional programming interface
 * @export
 */
export const UtilityRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRoleControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRoleControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRoleApi.utilRoleControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRoleControllerCreate(createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRoleControllerCreate(createRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRoleApi.utilRoleControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteRoleDto} deleteRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRoleControllerDelete(deleteRoleDto: DeleteRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRoleControllerDelete(deleteRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRoleApi.utilRoleControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditRoleDto} editRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRoleControllerEdit(editRoleDto: EditRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRoleControllerEdit(editRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRoleApi.utilRoleControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilRoleControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilRoleControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilRoleControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityRoleApi.utilRoleControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityRoleApi - factory interface
 * @export
 */
export const UtilityRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityRoleApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilRoleControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerCreate(createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRoleControllerCreate(createRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteRoleDto} deleteRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerDelete(deleteRoleDto: DeleteRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRoleControllerDelete(deleteRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditRoleDto} editRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerEdit(editRoleDto: EditRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilRoleControllerEdit(editRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilRoleControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilRoleControllerGet200Response> {
            return localVarFp.utilRoleControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityRoleApi - object-oriented interface
 * @export
 * @class UtilityRoleApi
 * @extends {BaseAPI}
 */
export class UtilityRoleApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRoleApi
     */
    public utilRoleControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityRoleApiFp(this.configuration).utilRoleControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRoleDto} createRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRoleApi
     */
    public utilRoleControllerCreate(createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig) {
        return UtilityRoleApiFp(this.configuration).utilRoleControllerCreate(createRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteRoleDto} deleteRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRoleApi
     */
    public utilRoleControllerDelete(deleteRoleDto: DeleteRoleDto, options?: RawAxiosRequestConfig) {
        return UtilityRoleApiFp(this.configuration).utilRoleControllerDelete(deleteRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditRoleDto} editRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRoleApi
     */
    public utilRoleControllerEdit(editRoleDto: EditRoleDto, options?: RawAxiosRequestConfig) {
        return UtilityRoleApiFp(this.configuration).utilRoleControllerEdit(editRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityRoleApi
     */
    public utilRoleControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityRoleApiFp(this.configuration).utilRoleControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityServiceApi - axios parameter creator
 * @export
 */
export const UtilityServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-service/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateServiceDto} createServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerCreate: async (createServiceDto: CreateServiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createServiceDto' is not null or undefined
            assertParamExists('utilServiceControllerCreate', 'createServiceDto', createServiceDto)
            const localVarPath = `/api/v1/util-service/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createServiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteServiceDto} deleteServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerDelete: async (deleteServiceDto: DeleteServiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteServiceDto' is not null or undefined
            assertParamExists('utilServiceControllerDelete', 'deleteServiceDto', deleteServiceDto)
            const localVarPath = `/api/v1/util-service/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteServiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditServiceDto} editServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerEdit: async (editServiceDto: EditServiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editServiceDto' is not null or undefined
            assertParamExists('utilServiceControllerEdit', 'editServiceDto', editServiceDto)
            const localVarPath = `/api/v1/util-service/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editServiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-service/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityServiceApi - functional programming interface
 * @export
 */
export const UtilityServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilServiceControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilServiceControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityServiceApi.utilServiceControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateServiceDto} createServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilServiceControllerCreate(createServiceDto: CreateServiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilServiceControllerCreate(createServiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityServiceApi.utilServiceControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteServiceDto} deleteServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilServiceControllerDelete(deleteServiceDto: DeleteServiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilServiceControllerDelete(deleteServiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityServiceApi.utilServiceControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditServiceDto} editServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilServiceControllerEdit(editServiceDto: EditServiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilServiceControllerEdit(editServiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityServiceApi.utilServiceControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilServiceControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilServiceControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilServiceControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityServiceApi.utilServiceControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityServiceApi - factory interface
 * @export
 */
export const UtilityServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilServiceControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateServiceDto} createServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerCreate(createServiceDto: CreateServiceDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilServiceControllerCreate(createServiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteServiceDto} deleteServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerDelete(deleteServiceDto: DeleteServiceDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilServiceControllerDelete(deleteServiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditServiceDto} editServiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerEdit(editServiceDto: EditServiceDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilServiceControllerEdit(editServiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilServiceControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilServiceControllerGet200Response> {
            return localVarFp.utilServiceControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityServiceApi - object-oriented interface
 * @export
 * @class UtilityServiceApi
 * @extends {BaseAPI}
 */
export class UtilityServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityServiceApi
     */
    public utilServiceControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityServiceApiFp(this.configuration).utilServiceControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateServiceDto} createServiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityServiceApi
     */
    public utilServiceControllerCreate(createServiceDto: CreateServiceDto, options?: RawAxiosRequestConfig) {
        return UtilityServiceApiFp(this.configuration).utilServiceControllerCreate(createServiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteServiceDto} deleteServiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityServiceApi
     */
    public utilServiceControllerDelete(deleteServiceDto: DeleteServiceDto, options?: RawAxiosRequestConfig) {
        return UtilityServiceApiFp(this.configuration).utilServiceControllerDelete(deleteServiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditServiceDto} editServiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityServiceApi
     */
    public utilServiceControllerEdit(editServiceDto: EditServiceDto, options?: RawAxiosRequestConfig) {
        return UtilityServiceApiFp(this.configuration).utilServiceControllerEdit(editServiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityServiceApi
     */
    public utilServiceControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityServiceApiFp(this.configuration).utilServiceControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilityStatusApi - axios parameter creator
 * @export
 */
export const UtilityStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerActivity: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-status/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStatusDto} createStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerCreate: async (createStatusDto: CreateStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStatusDto' is not null or undefined
            assertParamExists('utilStatusControllerCreate', 'createStatusDto', createStatusDto)
            const localVarPath = `/api/v1/util-status/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteStatusDto} deleteStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerDelete: async (deleteStatusDto: DeleteStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteStatusDto' is not null or undefined
            assertParamExists('utilStatusControllerDelete', 'deleteStatusDto', deleteStatusDto)
            const localVarPath = `/api/v1/util-status/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditStatusDto} editStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerEdit: async (editStatusDto: EditStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editStatusDto' is not null or undefined
            assertParamExists('utilStatusControllerEdit', 'editStatusDto', editStatusDto)
            const localVarPath = `/api/v1/util-status/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerGet: async (search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/util-status/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                for (const [key, value] of Object.entries(order)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (dateFilter !== undefined) {
                localVarQueryParameter['date_filter'] = dateFilter;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityStatusApi - functional programming interface
 * @export
 */
export const UtilityStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilStatusControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonControllerActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilStatusControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityStatusApi.utilStatusControllerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateStatusDto} createStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilStatusControllerCreate(createStatusDto: CreateStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilStatusControllerCreate(createStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityStatusApi.utilStatusControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteStatusDto} deleteStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilStatusControllerDelete(deleteStatusDto: DeleteStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilStatusControllerDelete(deleteStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityStatusApi.utilStatusControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EditStatusDto} editStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilStatusControllerEdit(editStatusDto: EditStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilStatusControllerEdit(editStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityStatusApi.utilStatusControllerEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilStatusControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilStatusControllerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilStatusControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilityStatusApi.utilStatusControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilityStatusApi - factory interface
 * @export
 */
export const UtilityStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityStatusApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonControllerActivity200Response> {
            return localVarFp.utilStatusControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStatusDto} createStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerCreate(createStatusDto: CreateStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilStatusControllerCreate(createStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteStatusDto} deleteStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerDelete(deleteStatusDto: DeleteStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilStatusControllerDelete(deleteStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditStatusDto} editStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerEdit(editStatusDto: EditStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.utilStatusControllerEdit(editStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {object} [order] 
         * @param {object} [filter] 
         * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
         * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilStatusControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<UtilStatusControllerGet200Response> {
            return localVarFp.utilStatusControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilityStatusApi - object-oriented interface
 * @export
 * @class UtilityStatusApi
 * @extends {BaseAPI}
 */
export class UtilityStatusApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityStatusApi
     */
    public utilStatusControllerActivity(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityStatusApiFp(this.configuration).utilStatusControllerActivity(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStatusDto} createStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityStatusApi
     */
    public utilStatusControllerCreate(createStatusDto: CreateStatusDto, options?: RawAxiosRequestConfig) {
        return UtilityStatusApiFp(this.configuration).utilStatusControllerCreate(createStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteStatusDto} deleteStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityStatusApi
     */
    public utilStatusControllerDelete(deleteStatusDto: DeleteStatusDto, options?: RawAxiosRequestConfig) {
        return UtilityStatusApiFp(this.configuration).utilStatusControllerDelete(deleteStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditStatusDto} editStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityStatusApi
     */
    public utilStatusControllerEdit(editStatusDto: EditStatusDto, options?: RawAxiosRequestConfig) {
        return UtilityStatusApiFp(this.configuration).utilStatusControllerEdit(editStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {object} [order] 
     * @param {object} [filter] 
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityStatusApi
     */
    public utilStatusControllerGet(search?: string, limit?: number, offset?: number, order?: object, filter?: object, dateFilter?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return UtilityStatusApiFp(this.configuration).utilStatusControllerGet(search, limit, offset, order, filter, dateFilter, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



